var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutUsLeftEx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 729.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #9d9fa2;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #b08234;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #5e5e61;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #868d8c;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #ccb090;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #e0c79d;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #c1a251;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #a2a3a6;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #c4c5c7;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #7f8487;\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #4d5655;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #747577;\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: #272525;\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: #bebcc0;\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: #adabae;\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: #5a7774;\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: #d0d0d3;\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: #e5e6e7;\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: #5f3324;\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: #626a68;\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: #959296;\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: #dfc07f;\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: #b2b3b3;\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: #eec83d;\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: #d1d0d2;\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: #efca46;\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: #e9e8e9;\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: #8d949c;\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: #bc9653;\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: #dfdfdf;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "711.83 559.25 658.01 590.41 658.01 698.39 711.83 667.29 711.83 559.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "614.48 565.26 658.01 590.41 658.01 698.39 614.48 673.24 614.48 565.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "711.83 559.25 668.39 534.07 614.48 565.26 658.01 590.41 711.83 559.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "655.03 662.21 617.4 640.46 617.4 671.5 655.03 693.25 655.03 662.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "655.03 627.54 617.4 605.8 617.4 636.84 655.03 658.58 655.03 627.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "655.03 592.97 617.4 571.22 617.4 602.26 655.03 624.01 655.03 592.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M640.34,591.54l-8.24-4.76c-.84-.49-1.53-1.8-1.53-2.92h0c0-1.12,.69-1.64,1.53-1.16l8.24,4.76c.84,.49,1.53,1.8,1.53,2.92h0c0,1.12-.69,1.64-1.53,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M640.34,626.25l-8.24-4.76c-.84-.49-1.53-1.8-1.53-2.92h0c0-1.12,.69-1.64,1.53-1.16l8.24,4.76c.84,.49,1.53,1.8,1.53,2.92h0c0,1.12-.69,1.64-1.53,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M640.34,660.95l-8.24-4.76c-.84-.49-1.53-1.8-1.53-2.92h0c0-1.12,.69-1.64,1.53-1.16l8.24,4.76c.84,.49,1.53,1.8,1.53,2.92h0c0,1.12-.69,1.64-1.53,1.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "645.12 554.06 672.15 569.72 653.9 580.27 626.88 564.58 645.12 554.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "655.94 562.81 663.41 567.12 649.13 575.3 641.66 570.99 655.94 562.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "653.9 561.63 654.49 561.97 640.21 570.14 639.62 569.81 653.9 561.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "652.57 560.86 653.17 561.2 638.88 569.39 638.29 569.04 652.57 560.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "651.16 560.05 651.76 560.4 637.47 568.58 636.88 568.23 651.16 560.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "649.82 559.27 650.41 559.61 636.12 567.79 635.53 567.45 649.82 559.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "648.48 558.5 649.08 558.85 634.79 567.03 634.2 566.68 648.48 558.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "647.08 557.69 647.67 558.04 633.39 566.22 632.8 565.87 647.08 557.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "664.91 567.99 665.51 568.33 651.22 576.51 650.63 576.17 664.91 567.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "644.2 556.01 646.28 557.21 632.01 565.39 629.92 564.19 644.2 556.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "672.15 569.72 672.15 571.04 653.9 581.59 653.9 580.27 672.15 569.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "626.9 564.59 653.9 580.27 653.9 581.59 626.9 565.91 626.9 564.59"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 660.82,
    cy: 553.72,
    rx: 6.7,
    ry: 3.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "649.75 537 654.16 554.11 667.43 554.29 672.6 537 649.75 537"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M661.22,529.92c-6.4,0-11.59,2.76-11.59,6.17s5.19,6.17,11.59,6.17,11.59-2.76,11.59-6.17-5.19-6.17-11.59-6.17Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M671.53,535.76c0-2.8-4.65-5.07-10.38-5.07s-10.38,2.27-10.38,5.07c0,.61,.25,1.18,.66,1.72,.73-2.87,4.92-5.86,13.34-4.73,3.18,.43,5.88,2.63,5.71,5.21,.66-.67,1.07-1.41,1.07-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M664.75,532.76c-8.41-1.13-12.61,1.86-13.34,4.73,1.45,1.95,5.24,3.35,9.73,3.35,4.11,0,7.63-1.18,9.32-2.87,.17-2.58-2.53-4.78-5.71-5.21Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M634.19,501.37c.76-1.32,4.55-2.22,5.78-.85s2.18,3.82,5.3,3.83c3.13,0,5.24,1.08,5.7,3.86,.46,2.78-.92,3.26,1.99,3.68,2.91,.42,6.42,.9,6.28,4.02-.14,3.13-1.85,5.87-1,7.01,.85,1.14,2.65,5.4,2.94,7.44,.28,2.03,.47,4.64,.47,4.64,0,0-.81,1.37-1.71,.16-.28-1.47,.67-5.34-1.22-8.11-1.89-2.78-3.01-2.03-5.76-2.87-2.75-.84-5.8-2.38-6.75-4s1.29-4.58-1.55-5.72c-2.84-1.14-6.03,1.31-7.5-2.07-.96-2.21-.22-5.46,.1-6.8,.47-2.03,1.37-3.89-3.08-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M691.24,500.87c-.79-1.38-4.76-2.33-6.05-.89-1.29,1.44-2.28,4-5.55,4.01-3.27,0-5.49,1.13-5.97,4.04-.48,2.91,.96,3.41-2.09,3.85-3.05,.44-6.72,.94-6.57,4.21,.15,3.27,1.93,6.15,1.04,7.34-.89,1.19-2.78,5.66-3.07,7.79-.3,2.13-.5,4.86-.5,4.86,0,0,.84,1.44,1.79,.17,.3-1.54-.7-5.59,1.28-8.49,1.98-2.91,3.15-2.13,6.03-3.01,2.88-.88,6.07-2.49,7.06-4.18,.99-1.69-1.35-4.8,1.62-5.99,2.97-1.19,6.31,1.37,7.85-2.17,1.01-2.32,.23-5.71-.1-7.12-.5-2.13-1.44-4.07,3.22-4.41Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M658.44,536.36s-2.38-4.69-4.24-6.74c-1.86-2.04-3.9-5.05-7.25-4.05-2.8,.84-5.91,2.6-7.7,2.01-1.79-.6-3.94-2.45-6.03-2.73-5.02-.67-5.72,3.71-5.72,3.71,0,0-1.71-4.1,1.34-8.16,1.61-2.14,6.06-3.78,8.74-2.71,2.68,1.07,4.77,.84,5.36,.14,1.52-1.78,3.75-.7,4.34,.58,.59,1.28,2.07,1.72,3.61,1.02,1.79-.82,3.37,1.07,3.83,2.39,.46,1.32-.74,4.03-.52,5.04,.22,1.01,4.37,6.73,5.39,8.67,.37,.78-.52,1.3-1.15,.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M652.52,522.37c-2.11-2.55-6.46-1.69-9.62-1.11-1.47,.27-4.23-.5-7.3-1.25-2.64-.64-4.78-.19-6.41,2.33,3.24-3.72,7.76-1.23,10.24-.58,4.38,1.16,10.94-2.72,13.66,2.28,.03-.62-.37-1.43-.58-1.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M667.58,537.35s.89-5.19,2.07-7.69c1.18-2.5,2.24-5.98,5.74-6.01,2.92-.02,6.42,.75,7.95-.35,1.53-1.09,3.05-3.5,4.96-4.38,4.6-2.12,6.56,1.86,6.56,1.86,0,0,.43-4.42-3.68-7.4-2.17-1.57-6.91-1.83-9.15-.02-2.24,1.81-4.32,2.21-5.08,1.72-1.97-1.25-3.79,.43-3.98,1.83s-1.47,2.26-3.14,2.04c-1.96-.25-2.9,2.02-2.96,3.42s1.9,3.63,1.98,4.66-2.19,7.72-2.6,9.88c-.13,.86,.88,1.09,1.34,.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M669.11,522.23c1.27-3.06,5.68-3.51,8.86-3.89,1.48-.18,3.9-1.73,6.61-3.35,2.33-1.39,4.51-1.59,6.81,.34-4.2-2.6-7.78,1.11-9.96,2.47-3.85,2.4-11.25,.62-12.38,6.2-.21-.58-.06-1.48,.06-1.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M652.68,498.08s3.13-.54,6.1,1.18c2.98,1.72,3.18,5.19,3.42,7.76,.25,2.57,.94,2.48,2.92,4.19,1.98,1.71,4.02,5.99,1.93,7.99-2.08,2-4.81,5.07-2.67,7.53,1.26,1.46,1.18,4.53,.49,7.06-.47,1.72-1.62,3.66-2.68,4.4-.79,.56-1.44-.14-1.44-.14,0,0,2.92-3.11,2.28-5.7-.64-2.59-6.57-1.67-5.75-5.62,.82-3.95,.95-3.81-2.53-6.47-3.7-2.83-4.81-4.74-2.21-9.49,2.61-4.75,4.18-7.81,.12-12.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M655.96,499.83s2.88,2.82,2.33,6.58c-.55,3.77-2.38,6.74-.35,9.97,2.03,3.22,3.12,3.88,2.78,5.51-.35,1.63-1.78,3.52-.62,4.83,1.16,1.31,3.44,2.35,3.44,2.35,0,0-3.72-2.03-2.83-4.56,.89-2.53,1.94-3.93,.94-5.76s-4.86-2.87-4.02-5.84c.84-2.97,2.63-6.64,1.24-9.62-1.39-2.97-2.93-3.46-2.93-3.46Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 685.47,
    cy: 562.24,
    rx: 6.7,
    ry: 3.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "674.4 551.69 678.81 562.72 691.93 563.18 697.25 551.69 674.4 551.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M685.86,544.61c-6.4,0-11.59,2.76-11.59,6.17s5.19,6.17,11.59,6.17,11.59-2.76,11.59-6.17-5.19-6.17-11.59-6.17Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M696.17,550.46c0-2.8-4.65-5.07-10.38-5.07s-10.38,2.27-10.38,5.07c0,.61,.25,1.18,.66,1.72,.73-2.87,4.92-5.86,13.34-4.73,3.18,.43,5.88,2.63,5.71,5.21,.66-.67,1.07-1.41,1.07-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M689.4,547.45c-8.41-1.13-12.61,1.86-13.34,4.73,1.45,1.95,5.24,3.35,9.73,3.35,4.11,0,7.63-1.18,9.32-2.87,.17-2.58-2.53-4.78-5.71-5.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M684.4,534.98c-.1-.39-.17-2.47,.54-4.92,.81-2.81,2.5-3.71,2.5-3.71,0,0-.65,2.6-.27,4.5,.38,1.9,.75,4.13,.75,4.13,0,0-2.44,4.21-3.52,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M681.05,528.16s1.27,4.81,.95,8.15c-.33,3.34,4.02,4.91,4.87,2.54,1.29-3.63-2.33-7.97-5.82-10.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M685.77,538.85c-.14-.46,.08-3.81,1.1-6.25s3.47-3.98,3.47-3.98c0,0-1,2.31-.63,4.51s1.15,4.79,1.15,4.79l-2.06,5-3.03-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M678.29,526.35s-.37,6.52,.77,9.87c1.14,3.35,4.52,8.47,4.52,8.47l2.2-4.4s-2.96-3.93-4.72-7.17c-1.76-3.24-2.76-6.77-2.76-6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M676.66,539.93s-.8-3.75-1.39-6.81-.73-4.96-.73-4.96c0,0,3.85,4.93,5.2,7.36,1.36,2.42,3.83,8.78,3.83,8.78l-2.5,4.06-4.41-8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M693.78,539.93s.8-3.75,1.39-6.81,.73-4.96,.73-4.96c0,0-3.85,4.93-5.2,7.36-1.36,2.42-3.83,8.78-3.83,8.78l2.5,4.06,4.41-8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M681.08,548.36c-.28-.42,1.73-7.63,2.5-9.67s3.39-2.78,4.59,0c1.2,2.78,2.69,9.98,2.69,9.98,0,0-4.89,7.12-9.78-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M668.79,535.52s3.09-.3,4.62,3.37c1.53,3.67,3.34,11.43,7.26,14.3,2.17,1.59,7.48,.76,7.48,.76,0,0-5.08-7.98-8.78-13.04-3.71-5.06-7.15-7.73-10.59-5.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M702.94,535.52s-3.09-.3-4.62,3.37c-1.53,3.67-3.17,11.3-6.92,14.4-2.65,2.19-8.42,1.22-8.42,1.22,0,0,5.66-8.54,9.37-13.59,3.71-5.06,7.15-7.73,10.59-5.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M683.57,538.85s1.13,.81,1.61,1.67c.23,.41,.85,1.22,.85,1.22,0,0,.49-1.25,.89-1.73,.46-.56,1.24-1.15,1.24-1.15l-2.03,4.58s-1.38-1.81-1.69-2.58c-.41-1.05-.87-2-.87-2Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "390.81 197.94 443.1 166.97 379.73 120.11 327.33 150.38 372.79 176.64 390.81 197.94"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M342.78,174.78v-25.47c-7.98-4.61-15.45-8.93-15.45-8.93v100.04l63.57,36.74v-68.86l-43.83-25.3c-2.36-1.36-4.3-5.06-4.3-8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359.13,168.5c-3.5-2.02-10.08-5.82-16.35-9.45v15.73c0,3.15,1.93,6.85,4.3,8.21l43.83,25.3v-8.39c0-8.07-4.3-15.53-11.29-19.56-7.3-4.22-16.2-9.36-20.49-11.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M411.32,138.14c-3.5-2.02-10.08-5.82-16.35-9.45v15.73c0,3.15,1.93,6.85,4.3,8.21l43.83,25.3v-8.39c0-8.07-4.3-15.53-11.29-19.56-7.3-4.22-16.2-9.36-20.49-11.84Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "342.78 159.05 395.32 129.11 395.32 119.21 342.78 149.31 342.78 159.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "443.1 166.97 390.91 197.12 390.91 277.16 443.1 247.01 443.1 166.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "327.33 233.75 390.91 270.55 390.91 269.23 327.33 232.57 327.33 233.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "327.33 222.89 390.91 259.7 390.91 258.38 327.33 221.71 327.33 222.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "327.33 212.32 390.91 249.13 390.91 247.81 327.33 211.14 327.33 212.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "327.33 201.47 390.91 238.28 390.91 236.96 327.33 200.29 327.33 201.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "327.33 190.9 390.91 227.7 390.91 226.39 327.33 189.72 327.33 190.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "327.33 180.13 390.91 216.93 390.91 215.61 327.33 178.94 327.33 180.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "413.19 202.76 390.91 215.61 390.91 216.93 413.19 204.03 413.19 202.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "413.19 213.53 390.91 226.39 390.91 227.7 413.19 214.8 413.19 213.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "413.19 224.18 390.91 237.04 390.91 238.36 413.19 225.45 413.19 224.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "413.19 234.95 390.91 247.81 390.91 249.13 413.19 236.23 413.19 234.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "413.19 245.6 390.91 258.46 390.91 259.78 413.19 246.88 413.19 245.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "413.19 256.38 390.91 269.23 390.91 270.55 413.19 257.65 413.19 256.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M341.45,223.51s6.66,7.03,14.51,11.6c9.06,5.28,16.85,6.52,16.85,6.52l-31.36-18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M341.45,212.65s6.66,7.03,14.51,11.6c9.06,5.28,16.85,6.52,16.85,6.52l-31.36-18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M341.45,202.08s6.66,7.03,14.51,11.6c9.06,5.28,16.85,6.52,16.85,6.52l-31.36-18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M341.45,191.23s6.66,7.03,14.51,11.6c9.06,5.28,16.85,6.52,16.85,6.52l-31.36-18.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "421.95 131.48 379.75 107.01 346.58 126.08 388.96 150.55 421.95 131.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "369.9 160.9 388.27 171.51 412.31 157.73 415.73 146.24 390.41 142.9 369.9 160.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M375.38,162.03l13.58-7.85-42.38-24.47-19.24,11.07,36.8,21.26c3.48,2.01,7.77,2.01,11.25,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "369.76 161.51 388.96 154.17 422.21 134.85 422.21 131.22 369.76 161.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M375.38,158.3l13.58-7.85-42.38-24.47-19.24,11.07,36.8,21.26c3.48,2.01,7.77,2.01,11.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M353.26,148.15l-18.02-10.4c-.95-.55-.83-1.51,.27-2.14l9.63-5.56c1.09-.63,2.76-.7,3.71-.15l18.02,10.4c.95,.55,.83,1.51-.27,2.14l-9.63,5.56c-1.09,.63-2.76,.7-3.71,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M346.36,126.1s-.86-8.7,3.11-10.86c3.97-2.17,30.37-17.5,30.37-17.5l-.31,9.39-33.17,18.97Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "379.84 97.74 383.52 99.9 382.63 104.33 422.21 125.41 388.82 150.55 346.36 126.11 379.84 97.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M351.6,122.27s6.66,7.03,14.51,11.6c9.06,5.28,16.85,6.52,16.85,6.52l-31.36-18.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "409.26 139.13 409.26 151.88 422.21 144.43 422.21 131.22 409.26 139.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "390.81 197.03 390.91 208.29 443.1 177.93 443.1 166.97 390.81 197.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "327.33 140.77 327.33 137.05 333.37 140.54 327.33 140.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M358.03,120.09l33.9,19.59v3.21l30.28-17.49-38.65-22.27-24.8,14.33c-.85,.49-1.45,1.05-1.87,1.64,.28,.36,.64,.7,1.14,.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M358.76,114.26c-2.4,1.39-3.05,3.36-1.87,4.85,.41-.59,1.02-1.15,1.87-1.64l24.72-14.28v-3.21l-24.72,14.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M391.93,139.69c-3.97,2.17-3.11,10.86-3.11,10.86l33.39-19.34v-5.81l-30.28,17.49v-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M359.98,121.19l26.11-20.24c1.21-.94,2.86-1.05,4.19-.29l20.21,11.68c2.26,1.31,2.53,4.46,.53,6.14l-22.81,19.04-28.24-16.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M359.12,120.72l26.97-20.99c1.21-.94,2.86-1.05,4.19-.29l20.21,11.68c2.26,1.31,2.53,4.46,.53,6.14l-23.66,19.79-28.24-16.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "445.54 146.23 392.81 146.38 392.81 148.27 445.54 148.27 445.54 146.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M416.82,162.13l-24.01-13.86,27.55-15.78,23.9,13.8c1.91,1.1,1.67,3.05-.54,4.32l-19.42,11.21c-2.21,1.27-5.57,1.41-7.48,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M416.82,160.24l-24.01-13.86,27.55-15.78,23.9,13.8c1.91,1.1,1.67,3.05-.54,4.32l-19.42,11.21c-2.21,1.27-5.57,1.41-7.48,.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "392.81 146.38 392.81 143.72 420.36 127.83 420.36 130.6 392.81 146.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "416.74 132.67 440.65 146.51 420.91 157.83 396.93 144.02 416.74 132.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "361.85 122.27 388.38 102.04 408.51 114.2 384.39 135.33 361.85 122.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "412.38 195.8 412.38 264.75 413.69 264 413.69 195.04 412.38 195.8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "443.2 299.34 440.09 297.55 440.09 124.84 443.2 126.64 443.2 299.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "493.28 97.89 443.2 126.64 443.2 299.34 490.17 272.38 490.17 272.39 492.01 271.33 492.01 271.33 492.01 271.33 493.28 270.59 493.28 97.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "440.09 124.84 443.2 126.64 493.28 97.89 490.04 95.95 440.09 124.84"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "443.2 240.75 489.59 213.82 557.42 252.88 512.34 280.79 443.2 240.75"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M455.6,242.29l13.19,7.61c1.03,.59,2.84,.52,4.02-.17l22.61-13.06c1.19-.68,1.32-1.73,.29-2.32l-13.19-7.61c-1.03-.59-2.84-.52-4.02,.17l-22.61,13.06c-1.19,.68-1.32,1.73-.29,2.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 495.09,
    y: 233.79,
    width: 1.31,
    height: 1.61,
    transform: "translate(991.5 469.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 454.91,
    y: 239.84,
    width: 1.31,
    height: 1.35,
    transform: "translate(911.13 481.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M455.6,240.82l13.19,7.61c1.03,.59,2.84,.52,4.02-.17l22.61-13.06c1.19-.68,1.32-1.73,.29-2.32l-13.19-7.61c-1.03-.59-2.84-.52-4.02,.17l-22.61,13.06c-1.19,.68-1.32,1.73-.29,2.32Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "492.21 233.88 479.99 226.79 458.28 239.83 470.49 246.91 492.21 233.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M492.55,231.06l-3.65,2.27-7.99-4.82,3.47-2.17s1.07,.65,1.76,.99c.69,.34,1.62-1.01,3.78,.13,2.46,1.3-.07,2.04,.73,2.49,.59,.33,1.9,1.1,1.9,1.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "496.76 239.27 477.95 250.16 491.46 257.91 510.32 247.05 496.76 239.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "487.47 246.03 480.62 250.04 491.46 256.24 498.36 252.27 487.47 246.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "490.2 244.47 489.16 245.1 500.01 251.3 501.09 250.71 490.2 244.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "492.43 243.18 491.4 243.8 502.24 250 503.32 249.41 492.43 243.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "491.46 257.91 491.46 262.09 510.32 251.22 510.32 247.05 491.46 257.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "477.95 250.16 477.95 251.14 490.68 258.44 490.68 260.81 477.95 253.51 477.95 254.34 491.46 262.09 491.46 257.91 477.95 250.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "490.68 258.44 477.95 251.14 477.95 253.51 490.68 260.81 490.68 258.44"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "496.76 234.02 477.95 244.91 491.46 252.66 510.32 241.8 496.76 234.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "487.47 240.79 480.62 244.79 491.46 250.99 498.36 247.02 487.47 240.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "490.2 239.23 489.16 239.85 500.01 246.05 501.09 245.46 490.2 239.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "492.43 237.93 491.4 238.55 502.24 244.75 503.32 244.16 492.43 237.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "491.46 252.66 491.46 256.84 510.32 245.98 510.32 241.8 491.46 252.66"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "477.95 244.91 477.95 245.89 490.68 253.19 490.68 255.57 477.95 248.26 477.95 249.09 491.46 256.84 491.46 252.66 477.95 244.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "490.68 253.19 477.95 245.89 477.95 248.26 490.68 255.57 490.68 253.19"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "512.46 248.37 493.65 259.26 507.16 267.01 526.02 256.14 512.46 248.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "503.17 255.13 496.32 259.14 507.16 265.34 514.06 261.37 503.17 255.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "505.9 253.57 504.87 254.2 515.71 260.4 516.79 259.81 505.9 253.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "508.14 252.27 507.1 252.9 517.94 259.1 519.03 258.51 508.14 252.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "507.16 267.01 507.16 271.19 526.02 260.32 526.02 256.14 507.16 267.01"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "493.65 259.26 493.65 260.24 506.39 267.54 506.39 269.91 493.65 262.61 493.65 263.44 507.16 271.19 507.16 267.01 493.65 259.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "506.39 267.54 493.65 260.24 493.65 262.61 506.39 269.91 506.39 267.54"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "512.46 243.46 493.65 254.35 507.16 262.1 526.02 251.23 512.46 243.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "503.17 250.22 496.32 254.22 507.16 260.43 514.06 256.45 503.17 250.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "505.9 248.66 504.87 249.28 515.71 255.49 516.79 254.89 505.9 248.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "508.14 247.36 507.1 247.98 517.94 254.19 519.03 253.59 508.14 247.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "507.16 262.1 507.16 266.27 526.02 255.41 526.02 251.23 507.16 262.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "493.65 254.35 493.65 255.32 506.39 262.63 506.39 265 493.65 257.7 493.65 258.53 507.16 266.27 507.16 262.1 493.65 254.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "506.39 262.63 493.65 255.32 493.65 257.7 506.39 265 506.39 262.63"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "443.21 243.8 443.21 299.27 476.25 318.38 512.34 339.38 512.34 283.67 443.21 243.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "512.34 283.9 443.21 243.91 443.21 240.74 512.34 280.79 512.34 283.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "443.2 204.86 489.59 177.92 557.42 216.99 512.34 244.9 443.2 204.86"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "484.86 195.49 477.76 191.52 477.76 221.67 484.86 225.77 484.86 195.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "482.7 200.51 479.92 198.95 479.92 215.12 482.7 216.72 482.7 200.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "484.86 197.06 477.76 193.1 477.76 195.26 484.86 199.27 484.86 197.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M482.7,220.45c0,1.02-.62,1.49-1.39,1.05s-1.39-1.63-1.39-2.65,.62-1.49,1.39-1.05c.77,.44,1.39,1.63,1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "484.86 195.49 484.86 225.77 507.5 212.74 507.5 182.42 484.86 195.49"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "506.44 181.81 484.7 194.36 479.72 191.49 501.3 178.87 500.6 178.47 477.76 191.52 484.86 195.49 507.5 182.42 506.44 181.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "484.7 194.36 506.44 181.81 501.3 178.87 479.72 191.49 484.7 194.36"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "496.18 202.12 489.08 198.15 489.08 228.3 496.18 232.4 496.18 202.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "494.02 207.14 491.24 205.59 491.24 221.75 494.02 223.35 494.02 207.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "496.18 203.69 489.08 199.73 489.08 201.9 496.18 205.91 496.18 203.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M494.02,227.08c0,1.02-.62,1.49-1.39,1.05-.77-.44-1.39-1.63-1.39-2.65s.62-1.49,1.39-1.05c.77,.44,1.39,1.63,1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "496.18 202.12 496.18 232.4 518.82 219.37 518.82 189.05 496.18 202.12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "517.76 188.44 496.02 201 491.04 198.12 512.62 185.51 511.92 185.11 489.08 198.15 496.18 202.12 518.82 189.05 517.76 188.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "496.02 201 517.76 188.44 512.62 185.51 491.04 198.12 496.02 201"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "507.68 208.75 500.58 204.78 500.58 234.93 507.68 239.04 507.68 208.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "505.52 213.77 502.74 212.22 502.74 228.38 505.52 229.99 505.52 213.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "507.68 210.32 500.58 206.37 500.58 208.53 507.68 212.54 507.68 210.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M505.52,233.71c0,1.02-.62,1.49-1.39,1.05-.77-.44-1.39-1.63-1.39-2.65s.62-1.49,1.39-1.05c.77,.44,1.39,1.63,1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "507.68 208.75 507.68 239.04 530.32 226 530.32 195.68 507.68 208.75"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "529.26 195.07 507.52 207.63 502.54 204.75 524.12 192.14 523.42 191.74 500.58 204.78 507.68 208.75 530.32 195.68 529.26 195.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "507.52 207.63 529.26 195.07 524.12 192.14 502.54 204.75 507.52 207.63"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "512.34 248.01 443.21 208.02 443.21 204.85 512.34 244.9 512.34 248.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "443.2 166.39 489.59 139.46 557.42 178.52 512.34 206.43 443.2 166.39"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "457.58 140.12 450.48 136.15 450.48 166.3 457.58 170.4 457.58 140.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "455.42 145.14 452.64 143.59 452.64 159.75 455.42 161.35 455.42 145.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "457.58 141.69 450.48 137.73 450.48 139.9 457.58 143.91 457.58 141.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M455.42,165.08c0,1.02-.62,1.49-1.39,1.05-.77-.44-1.39-1.63-1.39-2.65s.62-1.49,1.39-1.05c.77,.44,1.39,1.63,1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "457.58 140.12 457.58 170.4 480.22 157.37 480.22 127.05 457.58 140.12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "479.15 126.44 457.42 138.99 452.44 136.12 474.02 123.51 473.32 123.11 450.48 136.15 457.58 140.12 480.22 127.05 479.15 126.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "457.42 138.99 479.15 126.44 474.02 123.51 452.44 136.12 457.42 138.99"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "469.08 146.75 461.98 142.78 461.98 172.93 469.08 177.03 469.08 146.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "466.92 151.77 464.14 150.22 464.14 166.38 466.92 167.99 466.92 151.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "469.08 148.32 461.98 144.36 461.98 146.53 469.08 150.54 469.08 148.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M466.92,171.71c0,1.02-.62,1.49-1.39,1.05-.77-.44-1.39-1.63-1.39-2.65s.62-1.49,1.39-1.05c.77,.44,1.39,1.63,1.39,2.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "469.08 146.75 469.08 177.03 491.72 164 491.72 133.68 469.08 146.75"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "490.66 133.07 468.92 145.63 463.94 142.75 485.52 130.14 484.82 129.74 461.98 142.78 469.08 146.75 491.72 133.68 490.66 133.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "468.92 145.63 490.66 133.07 485.52 130.14 463.94 142.75 468.92 145.63"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "497.34 163.25 472.39 177.7 489.23 187.45 514.17 172.96 497.34 163.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "487.35 171.33 480.46 175.31 493.64 182.85 500.54 178.88 487.35 171.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "489.24 170.24 488.69 170.55 501.88 178.1 502.42 177.79 489.24 170.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "490.46 169.53 489.91 169.84 503.1 177.4 503.65 177.08 490.46 169.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "479.07 176.11 478.52 176.43 491.71 183.97 492.26 183.66 479.07 176.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "477.58 176.97 475.66 178.08 488.83 185.63 490.76 184.52 477.58 176.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "472.39 177.7 472.39 178.92 489.23 188.67 489.23 187.45 472.39 177.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "514.16 172.97 489.23 187.45 489.23 188.67 514.16 174.19 514.16 172.97"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "497.34 160.75 472.39 175.21 489.23 184.95 514.17 170.46 497.34 160.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "487.35 168.83 480.46 172.81 493.64 180.36 500.54 176.38 487.35 168.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "489.24 167.74 488.69 168.06 501.88 175.6 502.42 175.29 489.24 167.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "490.46 167.03 489.91 167.35 503.1 174.9 503.65 174.58 490.46 167.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "479.07 173.62 478.52 173.93 491.71 181.48 492.26 181.16 479.07 173.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "477.58 174.48 475.66 175.59 488.83 183.14 490.76 182.03 477.58 174.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "472.39 175.21 472.39 176.43 489.23 186.17 489.23 184.95 472.39 175.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "514.16 170.47 489.23 184.95 489.23 186.17 514.16 171.69 514.16 170.47"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "497.34 158.24 472.39 172.7 489.23 182.44 514.17 167.95 497.34 158.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "487.35 166.32 480.46 170.3 493.64 177.85 500.54 173.87 487.35 166.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "489.24 165.23 488.69 165.55 501.88 173.09 502.42 172.78 489.24 165.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "490.46 164.52 489.91 164.84 503.1 172.39 503.65 172.07 490.46 164.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "479.07 171.11 478.52 171.42 491.71 178.97 492.26 178.65 479.07 171.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "477.58 171.97 475.66 173.08 488.83 180.63 490.76 179.52 477.58 171.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "472.39 172.7 472.39 173.92 489.23 183.66 489.23 182.44 472.39 172.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "514.16 167.96 489.23 182.44 489.23 183.66 514.16 169.18 514.16 167.96"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "512.34 209.55 443.21 169.55 443.21 166.39 512.34 206.43 512.34 209.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "443.2 126.64 493.28 97.89 562.29 137.75 512.34 166.68 443.2 126.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "512.34 169.8 443.21 129.81 443.21 126.64 512.34 166.68 512.34 169.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "475.73 262.53 475.73 318.08 476.59 318.56 476.59 263 475.73 262.53"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "515.45 341.17 512.34 339.38 512.34 166.64 515.45 168.44 515.45 341.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "565.53 139.69 515.45 168.44 515.45 341.17 562.42 314.21 562.42 314.22 564.26 313.16 564.26 313.16 564.26 313.16 565.53 312.42 565.53 139.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "512.34 166.64 515.45 168.44 565.53 139.69 562.29 137.75 512.34 166.64"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "479.96 285.44 479.96 300.39 482.28 301.69 482.28 286.81 479.96 285.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "469.94 279.63 469.94 294.58 472.26 295.88 472.26 281 469.94 279.63"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M469.48,208.87c0,1.82-2.77,3.29-6.19,3.29s-6.19-1.47-6.19-3.29,2.77-3.29,6.19-3.29,6.19,1.47,6.19,3.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "453.07 197.9 457.17 209.29 469.41 209.46 474.17 197.9 453.07 197.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M463.66,191.36c-5.91,0-10.7,2.55-10.7,5.69s4.79,5.69,10.7,5.69,10.7-2.55,10.7-5.69-4.79-5.69-10.7-5.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M473.17,196.76c0-2.59-4.29-4.68-9.58-4.68s-9.58,2.1-9.58,4.68c0,.56,.24,1.09,.61,1.59,.67-2.65,4.55-5.41,12.31-4.36,2.93,.4,5.43,2.43,5.27,4.81,.61-.62,.99-1.3,.99-2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M466.92,193.99c-7.77-1.05-11.64,1.72-12.31,4.36,1.34,1.8,4.83,3.09,8.98,3.09,3.8,0,7.05-1.09,8.6-2.65,.16-2.38-2.33-4.41-5.27-4.81Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M460.23,197.43s-3.33-2.38-6.61-.79c-3.27,1.6-2.1,5.39-1.11,7.68,.98,2.3,1.41,4.6,0,5.99-1.41,1.39-6.16,2.99-3.81,5.73,1.21,1.41,4.36,3.43,2.54,5.82-1.16,1.53-.7,5.33-.7,5.33,0,0-1.86-2.17-.63-4.81,.9-1.92,.89-3.05-1.01-4.83-1.9-1.78-3.13-4.19-.7-5.92,2.44-1.73,4.81-2.13,4.06-4.51-.75-2.38-2.6-7.68-.96-10.05,2.19-3.15,8.31-2.91,9.59-.45,.59,1.13-.25,1.23-.68,.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M451.16,201.76s-1.11,1.04-1.89,2.33c-.79,1.29,.27,3.04,.27,3.04,0,0,1.01-.85,1.23-1.86,.22-1.01,.39-3.51,.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M449.47,217.31s-1.11,1.04-1.89,2.33c-.79,1.29,.27,3.04,.27,3.04,0,0,1.01-.85,1.23-1.86,.22-1.01,.39-3.51,.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M449.95,211.78s-1.02-1.13-2.29-1.94c-1.27-.81-3.04,.2-3.04,.2,0,0,.83,1.03,1.84,1.27,1.01,.25,3.5,.47,3.5,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M449.52,217.39s1.36-.68,2.84-.98,2.76,1.29,2.76,1.29c0,0-1.15,.66-2.17,.52-1.03-.14-3.43-.83-3.43-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M453.48,195.87s-1.36-.68-2.84-.98-2.76,1.29-2.76,1.29c0,0,1.15,.66,2.17,.52,1.03-.14,3.43-.83,3.43-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M451.62,197.97s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.23-1.86s-.39-3.51-.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M451.8,209.87s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.23-1.86-.22-1.01-.39-3.51-.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M451.16,220.48s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.23-1.86-.22-1.01-.39-3.51-.39-3.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M464.37,198.53c.29,2.97,1.18,5.82,.2,8.12-.98,2.3-1.41,4.6,0,5.99,1.41,1.39,6.16,2.99,3.81,5.73-1.21,1.41-4.36,3.43-2.54,5.82,1.16,1.53,.7,5.33,.7,5.33,0,0,1.86-2.17,.63-4.81-.9-1.92-.89-3.05,1.01-4.83,1.9-1.78,3.13-4.19,.7-5.92-2.44-1.73-4.81-2.13-4.06-4.51,.75-2.38,2.2-7.44,.96-10.05-.9-1.88,.45-3.62,1.85-2.96,1.12-1.73-3.65-2.13-3.24,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M465.92,204.09s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.23-1.86s-.39-3.51-.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M467.6,219.64s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.24-1.86-.22-1.01-.39-3.51-.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M467.12,214.11s1.02-1.13,2.29-1.94c1.27-.81,3.04,.2,3.04,.2,0,0-.83,1.03-1.84,1.27-1.01,.25-3.5,.47-3.5,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M467.55,219.72s-1.36-.68-2.84-.98c-1.48-.3-2.76,1.29-2.76,1.29,0,0,1.15,.66,2.17,.52,1.03-.14,3.43-.83,3.43-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M465.5,200.59s-1.38,.64-2.53,1.62c-1.15,.98-.7,2.97-.7,2.97,0,0,1.23-.49,1.75-1.38,.53-.89,1.47-3.21,1.47-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M465.28,212.2s-1.11,1.04-1.89,2.33c-.79,1.29,.27,3.04,.27,3.04,0,0,1.01-.85,1.24-1.86,.22-1.01,.39-3.51,.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M465.92,222.81s-1.11,1.04-1.89,2.33c-.79,1.29,.27,3.04,.27,3.04,0,0,1.01-.85,1.23-1.86s.39-3.51,.39-3.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M464.57,198.25s-2.47-.69-4.5,2.25c-2.07,3-1.36,5.78-.38,8.08,.98,2.3,1.41,4.6,0,5.99-1.41,1.39-6.16,2.99-3.81,5.73,1.21,1.41,4.36,3.43,2.54,5.82-1.16,1.53-.7,5.33-.7,5.33,0,0-1.86-2.17-.63-4.81,.9-1.92,.89-3.05-1.01-4.83-1.9-1.78-3.13-4.19-.7-5.92,2.44-1.73,4.81-2.13,4.06-4.51-.75-2.38-2.23-7.46-.96-10.05,2.02-4.1,5.35-4.83,6.35-3.82,.45,.46,.34,.73-.28,.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M458.34,206.02s-1.11,1.04-1.89,2.33c-.79,1.29,.27,3.04,.27,3.04,0,0,1.01-.85,1.23-1.86,.22-1.01,.39-3.51,.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M456.65,221.57s-1.11,1.04-1.89,2.33,.27,3.04,.27,3.04c0,0,1.01-.85,1.24-1.86s.39-3.51,.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M457.13,216.04s-1.02-1.13-2.29-1.94-3.04,.2-3.04,.2c0,0,.83,1.03,1.84,1.27,1.01,.25,3.5,.47,3.5,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M456.7,221.65s1.36-.68,2.84-.98,2.76,1.29,2.76,1.29c0,0-1.15,.66-2.17,.52-1.03-.14-3.43-.83-3.43-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M459.5,200.58s-1.36-.68-2.84-.98c-1.48-.3-2.76,1.29-2.76,1.29,0,0,1.15,.66,2.17,.52,1.03-.14,3.43-.83,3.43-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M458.98,201.76s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.24-1.86-.22-1.01-.39-3.51-.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M458.98,214.13s1.11,1.04,1.89,2.33c.79,1.29-.27,3.04-.27,3.04,0,0-1.01-.85-1.24-1.86-.22-1.01-.39-3.51-.39-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M458.34,224.74s1.11,1.04,1.89,2.33-.27,3.04-.27,3.04c0,0-1.01-.85-1.24-1.86s-.39-3.51-.39-3.51Z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "303.68 85.1 262.31 109.16 294.94 128.06 336.31 104.07 303.68 85.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "294.94 128.06 262.31 109.16 262.31 203.88 294.94 222.78 294.94 128.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M262.31,109.16s8.08-9.33,19.28-16.51c13.02-8.35,22.09-7.54,22.09-7.54l-41.37,24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M294.94,128.12s8.08-9.33,19.28-16.51c13.02-8.35,22.09-7.54,22.09-7.54l-41.37,24.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M270.23,113.72s8.08-9.33,19.28-16.51c13.02-8.35,22.09-7.54,22.09-7.54l-41.37,24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M285.76,122.74s8.08-9.33,19.28-16.51c13.02-8.35,22.09-7.54,22.09-7.54l-15.52-9.01-41.37,24.06,15.52,9.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "336.31 104.07 336.43 198.82 294.94 222.78 294.94 128.12 336.31 104.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "270.23 113.72 270.23 208.46 285.76 217.46 285.76 122.72 270.23 113.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M304.99,100.82c0,1.6-2.44,2.9-5.45,2.9s-5.45-1.3-5.45-2.9,2.44-2.9,5.45-2.9,5.45,1.3,5.45,2.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 294.1,
    y: 92.65,
    width: 10.89,
    height: 8.17
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.31,91.49c-11.86,0-21.48-5.12-21.48-11.43v7.66c0,6.31,9.62,11.43,21.48,11.43s21.48-5.12,21.48-11.43v-7.66c0,6.31-9.62,11.43-21.48,11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.83,42.74v37.33c0-6.31,9.62-11.43,21.48-11.43s21.48,5.12,21.48,11.43V42.74h-42.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M299.31,68.64c-11.86,0-21.48,5.12-21.48,11.43s9.62,11.43,21.48,11.43,21.48-5.12,21.48-11.43-9.62-11.43-21.48-11.43Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 277.94,
    y: 73.56,
    width: 42.8,
    height: 5.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M299.31,61.43c-11.86,0-21.48,5.12-21.48,11.43s9.62,11.43,21.48,11.43,21.48-5.12,21.48-11.43-9.62-11.43-21.48-11.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M320.79,42.74c0,6.31-9.62,11.43-21.48,11.43s-21.48-5.12-21.48-11.43,9.62-11.43,21.48-11.43,21.48,5.12,21.48,11.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M299.31,37.61c6.64,0,12.14,2.58,13.19,5.95,.12-.38,.2-.77,.2-1.17,0-3.93-5.99-7.12-13.38-7.12s-13.38,3.19-13.38,7.12c0,.4,.08,.79,.2,1.17,1.05-3.37,6.55-5.95,13.19-5.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.31,49.5c6.64,0,12.14-2.58,13.19-5.95-1.05-3.37-6.55-5.95-13.19-5.95s-12.14,2.58-13.19,5.95c1.05,3.37,6.55,5.95,13.19,5.95Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "272.98 121.48 272.98 122.94 272.98 124.23 282.99 130.45 282.99 127.61 272.98 121.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "275.47 128.59 275.47 129.6 282.99 134.28 282.99 133.18 275.47 128.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "270.17 169.52 270.17 170.53 285.74 180.16 285.74 179.07 270.17 169.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "275.47 131.44 275.47 132.44 282.99 137.12 282.99 136.03 275.47 131.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "275.47 134.28 275.47 135.29 282.99 139.96 282.99 138.87 275.47 134.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "274.25 127.84 272.98 127.05 272.98 139.83 274.25 140.67 274.25 127.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "270.23 142.12 285.76 151.09 285.76 176.88 270.23 167.92 270.23 142.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "285.74 158.91 270.23 167.92 285.74 176.9 285.74 158.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "285.74 160.89 273.93 167.76 285.74 174.6 285.74 160.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M275.57,139.29c0,.86,.53,1.87,1.17,2.24,.65,.37,1.17-.02,1.17-.89s-.53-1.87-1.17-2.24c-.65-.37-1.17,.02-1.17,.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M279.33,141.44c0,.86,.53,1.87,1.17,2.24,.65,.37,1.17-.02,1.17-.89s-.53-1.87-1.17-2.24c-.65-.37-1.17,.02-1.17,.89Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "49.07 398.7 240.72 287.96 237.19 285.92 45.59 396.7 49.07 398.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "49.07 398.7 49.07 528.4 240.72 417.66 240.72 287.96 49.07 398.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "45.59 396.7 45.59 526.56 49.07 528.56 49.07 398.7 45.59 396.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M343.98,381.91s-.44,17.79-.44,21.8,.56,12.37-6.49,15.34c-7.04,2.97-17.02,6.87-17.02,6.87l9.45,6.08s9.53-4.14,14.42-7.16c6.89-4.25,6.17-15.85,6.17-23.22s-1.26-16.98-1.26-16.98l-4.83-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M320.03,464.61h0c-2.07,0-3.77-1.7-3.77-3.77v-34.79c0-2.07,1.7-3.77,3.77-3.77h0c2.07,0,3.77,1.7,3.77,3.77v34.79c0,2.07-1.7,3.77-3.77,3.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M343.89,427.72c0,7.01-10.68,12.69-23.86,12.69s-23.86-5.68-23.86-12.69,10.68-12.69,23.86-12.69,23.86,5.68,23.86,12.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 296.17,
    y: 425.32,
    width: 47.71,
    height: 2.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M343.89,425.32c0,7.01-10.68,12.69-23.86,12.69s-23.86-5.68-23.86-12.69,10.68-12.69,23.86-12.69,23.86,5.68,23.86,12.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.76,423.95c0,6.68-10.18,12.09-22.73,12.09s-22.73-5.41-22.73-12.09,10.18-12.09,22.73-12.09,22.73,5.41,22.73,12.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "298.51 416.18 297.3 423.95 342.76 423.95 341.55 416.18 298.51 416.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.87,418.1c0,6.42-9.78,11.62-21.84,11.62s-21.84-5.2-21.84-11.62,9.78-11.62,21.84-11.62,21.84,5.2,21.84,11.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M366.16,410.26v-26.1c0-9.14-5.61-19.85-12.46-23.81l-6.5-3.76c-6.85-3.96-12.46,.28-12.46,9.42v26.1l31.43,18.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "338.92 356.04 333.59 359.2 338.36 362.37 338.92 356.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "360.98 413.34 366.16 410.26 360.03 404.21 360.98 413.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M360.98,413.34v-26.1c0-9.14-5.61-19.85-12.46-23.81l-6.5-3.76c-6.85-3.96-12.46,.28-12.46,9.42v26.1l31.43,18.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M297.67,482.56c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "298.87 481.35 296.42 479.91 292.42 488.79 294.97 490.27 298.87 481.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M300.23,484.04c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M292.66,481.12h0c-.73-1.26-.3-2.88,.97-3.61l50.17-28.96c1.26-.73,2.88-.3,3.61,.97h0c.73,1.26,.3,2.88-.97,3.61l-50.17,28.96c-1.26,.73-2.88,.3-3.61-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M343.79,482.09l-50.17-28.96c-1.26-.73-1.7-2.35-.97-3.61h0c.73-1.26,2.35-1.7,3.61-.97l50.17,28.96c1.26,.73,1.7,2.35,.97,3.61h0c-.73,1.26-2.35,1.7-3.61,.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M346.85,453.58c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "348.05 452.37 345.6 450.93 341.61 459.82 344.16 461.29 348.05 452.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M349.42,455.06c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M343.76,483.3c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "344.96 482.09 342.51 480.65 338.51 489.54 341.07 491.01 344.96 482.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M346.33,484.78c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M295.66,455.23c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "296.86 454.02 294.41 452.58 290.42 461.47 292.97 462.94 296.86 454.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M298.23,456.71c0,2.34-1.42,5.06-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.13,425.65s-7.66,6.41-7.11,13.18c.3,3.69-.14,5.34,.44,9.93,.55,4.33,.85,21.61,.61,27.31-.25,5.7-4,10.82-5.4,12.82-1.4,1.99,2.57,5.41,5.85,2.56,3.28-2.85,3.64-3.42,5.45-4.27,1.82-.85,3.32-4.84,2.14-9.4-1.18-4.56-.07-13.39,1.8-21.08,1.12-4.62,1-10.26,.94-14.53-.04-2.84,10.42-11.91,10.81-12.82,.98-2.28-15.54-3.7-15.54-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M277.67,488.88s-4.02,3.03-5.38,4.53,2.52,4.01,6.38,2.87c3.87-1.14,7.16-4.57,10.31-7.12,3.09-2.5,3.94-3.41,3.94-6.44,0-1.5-1.46-3.14-1.46-3.14,0,0-1.24,6.1-5.7,8.47-4.25,2.26-5.97,2.55-8.09,.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M295.85,435.62c-1.81,1.82-3.7,5.48-2.93,9.4,.71,3.64,1.27,6.41,1.29,10.26,.02,4.36,.85,22.36,.61,28.05-.25,5.7-4,10.82-5.4,12.82-1.4,1.99,2.57,5.41,5.85,2.56,3.28-2.85,3.64-3.42,5.45-4.27,1.82-.85,3.32-4.84,2.14-9.4-1.18-4.56-.07-13.39,1.8-21.08,1.86-7.69-.53-18.04,1.06-19.94,3.21-3.85,9.93-7.19,10.16-11.08,.28-4.85-4.55-12.84-9.35-10.66-1.6,.73-4.7,7.35-10.68,13.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M289.42,496.14s-4.02,3.03-5.38,4.53,2.52,4.01,6.38,2.87c3.86-1.14,7.16-4.57,10.31-7.12,3.09-2.5,3.94-3.41,3.94-6.44,0-1.5-1.46-3.14-1.46-3.14,0,0-1.24,6.1-5.7,8.47-4.25,2.26-5.98,2.55-8.09,.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M330.5,407.46s3.52,11.27-.76,18.99c-3.52,6.36-21.9,15.72-21.9,15.72,0,0-2.61-8.27-11-11.26-4.92-1.75-10.11-2.88-10.11-2.88l18.98-24.17s9.87,12.18,24.78,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M301.73,370.78s-5.33,6.24-7.11,8.19c-.66,.72-3.6,4.64-5.55,7.74-2.68,4.27-4.48,8-4.75,8.86-.71,2.24-2.25,6.45-1.26,8.32,1,1.87,5.18,4.3,6.71,.08,.78-2.14,.18-6.77,.5-7.41,.74-1.46,5.93-7.99,7.18-9.36,1.25-1.38,10.69-10.57,10.69-10.57l-6.42-5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M304.37,376.63s-1.09-.54-2.64-1.96c-1.87-1.7-1.87-3.49-1.87-3.49,0,0,7.99-9.83,11.1-12.01s8.17,2.52,8.17,2.52l-14.76,14.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.75,375.27c-.59-2.95-9.21-9.5-9.21-9.5,0,0-5.17,3.73-7,5.02-1.74,1.24-4.71,4.48-4.97,4.75-.01,0-.03,0-.04,0,.06-.55,.62-4.99,2.59-9.66,.62-1.47,0-5.88,0-5.88,0,0-.69-.21-1.69-.44-1.6,1.6-4.79,5.92-6.5,7.69-1.65,1.71-7.97,6.98-6.55,12.82,.42,1.73,.98,3.25,1.78,5.41,.9,2.43,.62,6.95,.37,9.41-.29,2.82-3.28,10.13-3.28,10.13,0,0,6.12,7.82,13.08,7.85,8.13,.03,14.16-5.41,14.16-5.41,0,0-1.35-12.37-.84-17.42,0,0,10.04-5.02,8.09-14.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M316.37,364.49s-5.08,5.8-4.69,8.1c1.28,1.23,4.26,3.65,4.26,3.65l3.43-11.33-3-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M309.28,348.69s-.57,4.92-.24,9.04c.93,11.76,1.18,14.27,2.44,17.6,2.35-6.08,6.84-11.48,6.84-11.48l-9.03-15.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "187.92 470.7 238.41 441.32 238.41 369.33 187.92 398.7 187.92 470.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "187.92 470.7 184.56 468.76 184.56 396.76 187.92 398.7 187.92 470.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "236.16 442.59 239.52 440.64 239.52 368.65 236.16 370.59 236.16 442.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "187.92 437.6 321.25 514.69 321.25 483.92 187.92 406.3 187.92 437.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "324.62 550.08 377.19 519.91 377.19 447.92 324.62 478.09 324.62 550.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "324.62 550.08 321.25 548.14 321.25 476.14 324.62 478.09 324.62 550.08"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "375.51 520.89 378.88 518.94 378.88 446.94 375.51 448.89 375.51 520.89"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "324.73 487.56 173 399.55 173 395.95 324.73 483.97 324.73 487.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "324.73 483.97 387.66 447.62 387.66 450.99 324.73 487.34 324.73 483.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "173 395.95 235.9 359.56 387.66 447.62 324.73 483.97 173 395.95"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "305.08 414.81 279.11 399.78 269.49 405.32 295.51 420.35 305.08 414.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "295.51 421.71 305.08 416.16 305.08 414.81 295.51 420.35 295.51 421.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "295.51 420.35 295.51 421.71 269.49 406.6 269.49 405.32 295.51 420.35"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "292.14 418.41 291.65 418.13 301.23 412.59 301.73 412.87 292.14 418.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "288.35 416.22 287.86 415.94 297.44 410.4 297.94 410.68 288.35 416.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "284.57 414.03 284.08 413.75 293.66 408.21 294.15 408.49 284.57 414.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "280.82 411.85 280.33 411.57 289.91 406.03 290.4 406.31 280.82 411.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "303.23 415.88 303.71 415.6 277.7 400.57 277.21 400.85 303.23 415.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "301.34 417.03 301.82 416.75 275.78 401.7 275.29 401.98 301.34 417.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "299.37 418.13 299.85 417.85 273.85 402.81 273.35 403.1 299.37 418.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "297.41 419.31 297.94 419.05 271.84 403.97 271.35 404.25 297.41 419.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "277.13 409.71 276.64 409.42 286.22 403.89 286.71 404.17 277.13 409.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "273.48 407.6 272.99 407.32 282.57 401.79 283.06 402.06 273.48 407.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M327.65,387.2s-1.81,4.42-2.92,7.5c-1.11,3.08-3.89,5.26-5.51,6.2-1.29,.76-7.18,2.96-10.34,3.79-.66,.17-6.63,1.43-7.84,1.1-5.18-1.42-8.13-.54-10.46,.82s-2.55,3.68,3.46,4.03c6.01,.35,10.43,.57,13.9,.45,3.59-.12,8.23-.66,14.21-2.15,5.98-1.49,7.82-4.96,9.47-7.67,1.65-2.71,5.23-11,5.23-11l-9.2-3.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M318.57,360.65s-.18,5.02-1.2,7.65c-.8,1.12-1.73,4.74-1.44,7.94,1.69-.85,4.53-3.56,6.15-4.96,1.96-1.69,7.07-4.99,7.07-4.99l-.17-14.87-10.41,9.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M324.56,343c-3.29-2.5-11.07-3.31-13.91,4.74-2.98,8.43,4.65,18.97,8.72,17.18,2.28-1,7.07-4.56,8.41-9,1.52-5-.67-10.97-3.22-12.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M329.12,363.24s-3.2,1.95-6.01,4.87c-4.38,4.55-7.18,8.14-7.18,8.14,0,0,1.39,.98,6.58,1.43,4.2-4.05,7.81-6.53,9.27-9.25-.07-1.24-2.67-5.19-2.67-5.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M331.34,345.28c-1.36-2.51-4.56-5.94-6.91-6.91-4.71-1.94-7.95-.27-12.39,3.81-2.67,2.46-3.9,5.36-3.9,9.95,0,0,6.86,4.89,10.99,5.75,1.91,.4,4.56-.74,6.11-1.5,.18,2.11,.43,4.5,.37,5.64-.87,15.02-1.64,20.04-1.64,20.04,0,0,1.31-.03,3.17-3.32,1.01-1.79,3.15-4.3,4.72-10.09,.85-3.12,1.95-18.83-.52-23.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M336.25,394.18c1.21-2.52,2.23-4.81,2.65-6.19,1.12-3.65,1.91-9.97-1.93-14.28-3.84-4.31-8.96,5.06-9.87,8.26-.99,3.47-1.92,6.37-2.52,8.34,.33,5.13,8.49,5.18,11.67,3.87Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "274.39 428.64 262.25 421.63 257.72 428.64 264.83 434.82 274.39 428.64"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M289.38,386.78v35.55c0,2.66-2.88,4.32-5.18,2.99l-41.83-24.15c-1.07-.62-1.73-1.76-1.73-2.99v-35.55c0-2.66,2.88-4.32,5.18-2.99l41.83,24.15c1.07,.62,1.73,1.76,1.73,2.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "287.68 425.32 285.36 426.66 282.66 423.83 288.02 420.55 287.68 425.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "242.16 359.78 240.16 360.94 244.15 361.01 242.16 359.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.15,388.09v35.55c0,2.66-2.88,4.32-5.18,2.99l-41.83-24.15c-1.07-.62-1.73-1.76-1.73-2.99v-35.55c0-2.66,2.88-4.32,5.18-2.99l41.83,24.15c1.07,.62,1.73,1.76,1.73,2.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "254.33 399.09 254.33 430.52 263.9 436.06 263.9 404.65 254.33 399.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "254.33 399.09 255.59 398.39 265.15 403.95 263.9 404.65 254.33 399.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "265.15 403.95 263.9 404.65 263.9 436.06 265.15 435.36 265.15 403.95"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "264.83 435.54 274.39 429.99 274.39 428.64 264.83 434.18 264.83 435.54"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M308.98,441.69l-17.21,9.94c-1.19,.68-3.28,.6-4.64-.19l-11.07-6.39c-1.37-.79-1.52-2-.33-2.68l17.21-9.94c1.19-.68,3.28-.6,4.64,.19l11.07,6.39c1.37,.79,1.52,2,.33,2.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 274.92,
    y: 442.58,
    width: 10.87,
    height: 1.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 298.91,
    y: 439.56,
    width: 10.87,
    height: 1.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.98,440.59l-17.21,9.94c-1.19,.68-3.28,.6-4.64-.19l-11.07-6.39c-1.37-.79-1.52-2-.33-2.68l17.21-9.94c1.19-.68,3.28-.6,4.64,.19l11.07,6.39c1.37,.79,1.52,2,.33,2.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "294.76 431.93 276.76 442.35 289.69 449.77 307.74 439.37 294.76 431.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M302.41,435.02c0,.18-.28,.33-.62,.33s-.62-.15-.62-.33,.28-.33,.62-.33,.62,.15,.62,.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.28,419.5l-5.34-3.08h0c-.19-.12-.42-.2-.68-.2-3.84,0-8.13,6.83-8.13,6.83l5.43,3.11,8.99-6.02-.26-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M309.53,426.16l9.66-5.58s-.51-1.25-1.53-1.25c-3.84,0-8.13,6.83-8.13,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M306.21,424.25l.57,.33s.72-1.14,1.83-2.49l-.58-.32c-1.1,1.35-1.82,2.49-1.82,2.49Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "362.82 456.09 339.73 442.8 301.53 464.8 324.62 478.09 362.82 456.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.27,437.8c-12.23,7.06-21.41,12.34-21.41,12.34v13.66l38.2-22s-7.82-9.17-16.79-3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M322.94,438.81c-12.23,7.06-21.41,12.34-21.41,12.34v13.66l38.2-22s-7.82-9.17-16.79-3.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "333.25 443.72 306.22 459.38 324.46 469.94 351.48 454.24 333.25 443.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "322.42 452.48 314.96 456.78 329.23 464.96 336.71 460.65 322.42 452.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "324.46 451.29 323.87 451.63 338.16 459.81 338.75 459.47 324.46 451.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "325.79 450.52 325.2 450.87 339.48 459.05 340.07 458.7 325.79 450.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "313.45 457.66 312.86 458 327.14 466.17 327.74 465.83 313.45 457.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "311.83 458.59 309.75 459.79 324.03 467.97 326.12 466.77 311.83 458.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "306.22 459.38 306.22 460.7 324.46 471.26 324.46 469.94 306.22 459.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "351.46 454.25 324.46 469.94 324.46 471.26 351.46 455.57 351.46 454.25"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.36,451.08c-12.23,7.06-21.41,12.34-21.41,12.34v13.65l38.2-22s-7.82-9.17-16.79-3.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "299.85 450.14 299.85 463.71 324.62 478.09 324.62 464.43 299.85 450.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M346.03,452.09c-12.23,7.06-21.41,12.34-21.41,12.34v13.66l38.2-22s-7.82-9.17-16.79-3.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "299.85 450.14 324.62 464.43 324.64 462.43 301.6 449.11 299.85 450.14"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "204.36 367.01 204.36 382.88 192.85 373.17 204.36 367.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "216.13 375.19 216.13 391.07 204.62 381.36 216.13 375.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M207.22,382.35l-1.73-1,10.64-6.16-1.05-.61-11.72,6.77,2.88,1.68c.32-.24,.65-.46,.98-.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "195.44 365.21 195.44 400.03 217.05 387.57 217.05 352.89 195.44 365.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "196.91 366.06 196.91 400.88 218.53 388.42 218.53 353.74 196.91 366.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "198.6 367.16 198.6 401.99 220.22 389.52 220.22 354.84 198.6 367.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "199.28 377.67 191.59 373.17 191.59 398.67 199.28 403.29 199.28 377.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "199.28 396.9 191.59 392.24 191.59 394.95 199.28 399.61 199.28 396.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M221.72,378.41l-10.66,6.16-1.92-1.11c-.36,.21-.72,.42-1.06,.65l2.98,1.74,11.76-6.79-1.1-.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "199.28 377.67 199.28 403.29 222.82 389.75 222.82 379.06 211.06 385.85 211.05 370.88 199.28 377.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "209.95 370.23 199.29 376.39 193.72 373.16 195.44 372.17 195.44 370.95 191.59 373.17 199.29 377.67 211.05 370.88 209.95 370.23"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "216.51 374.34 216.51 390.22 205 380.5 216.51 374.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "228.28 382.53 228.28 398.4 216.77 388.69 228.28 382.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M219.37,389.68l-1.73-1,10.64-6.16-1.05-.61-11.72,6.77,2.88,1.68c.32-.24,.65-.46,.98-.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "207.59 372.54 207.59 407.37 229.2 394.9 229.2 360.22 207.59 372.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "209.06 373.39 209.06 408.22 230.68 395.76 230.68 361.07 209.06 373.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "210.75 374.49 210.75 409.32 232.37 396.86 232.37 362.18 210.75 374.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "211.43 385 203.74 380.5 203.74 406.01 211.43 410.63 211.43 385"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "211.43 404.23 203.74 399.58 203.74 402.29 211.43 406.94 211.43 404.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.87,385.75l-10.66,6.16-1.92-1.11c-.36,.21-.72,.42-1.06,.65l2.98,1.74,11.76-6.79-1.1-.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "211.43 385 211.43 410.63 234.97 397.08 234.97 386.39 223.21 393.19 223.2 378.21 211.43 385"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "222.1 377.56 211.44 383.72 205.87 380.5 207.59 379.5 207.59 378.28 203.74 380.5 211.44 385 223.2 378.21 222.1 377.56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 230.68,
    cy: 399.61,
    rx: 5.48,
    ry: 2.91
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M229.72,393.32c-.43,0-.77-.18-.77-.41v13.89h1.55v-13.89c0,.23-.35,.41-.77,.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M228.95,390.89v2.02c0-.23,.35-.41,.77-.41s.77,.18,.77,.41v-2.02h-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M229.72,392.5c-.43,0-.77,.18-.77,.41s.35,.41,.77,.41,.77-.18,.77-.41-.35-.41-.77-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M230.49,390.89c0,.23-.35,.41-.77,.41s-.77-.18-.77-.41,.35-.41,.77-.41,.77,.18,.77,.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M235.24,394.79c-.42-.1-.71-.36-.66-.58l-3.21,13.51,1.5,.36,3.21-13.51c-.05,.22-.43,.32-.85,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M235.05,392.24l-.47,1.97c.05-.22,.43-.32,.85-.22,.42,.1,.71,.36,.66,.58l.47-1.97-1.5-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M235.43,393.99c-.42-.1-.79,0-.85,.22-.05,.22,.24,.48,.66,.58,.42,.1,.79,0,.85-.22,.05-.22-.24-.48-.66-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.55,392.6c-.05,.22-.43,.32-.85,.22s-.71-.36-.66-.58c.05-.22,.43-.32,.85-.22s.71,.36,.66,.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M225.71,395.42c-.41,.13-.79,.06-.86-.16l4.17,13.25,1.47-.46-4.17-13.25c.07,.22-.21,.5-.61,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M224.24,393.33l.61,1.93c-.07-.22,.21-.5,.61-.62,.41-.13,.79-.06,.86,.16l-.61-1.93-1.47,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M225.46,394.63c-.41,.13-.68,.41-.61,.62,.07,.22,.45,.29,.86,.16,.41-.13,.68-.41,.61-.62-.07-.22-.45-.29-.86-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M225.71,392.87c.07,.22-.21,.5-.61,.62s-.79,.06-.86-.16c-.07-.22,.21-.5,.61-.62s.79-.06,.86,.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M230.68,402.52c-3.03,0-5.48-1.31-5.48-2.91v14.42h10.96v-14.42c0,1.61-2.45,2.91-5.48,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M236.16,414.03c0,1.61-2.45,2.91-5.48,2.91s-5.48-1.3-5.48-2.91,2.45-2.91,5.48-2.91,5.48,1.31,5.48,2.91Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M333.41,427.88l-9.7,5.6c-.48,.28-1.32,.24-1.88-.08l-4.7-2.72c-.56-.32-.62-.81-.13-1.08l9.7-5.6c.48-.28,1.32-.24,1.88,.08l4.7,2.72c.56,.32,.62,.81,.13,1.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 316.67,
    y: 429.08,
    width: 1.03,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 330.98,
    y: 426.41,
    width: 2.74,
    height: 1.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M333.41,426.85l-9.7,5.6c-.48,.28-1.32,.24-1.88-.08l-4.7-2.72c-.56-.32-.62-.81-.13-1.08l9.7-5.6c.48-.28,1.32-.24,1.88,.08l4.7,2.72c.56,.32,.62,.81,.13,1.08Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "317.85 428.93 322.73 431.88 331.36 426.89 326.48 423.95 317.85 428.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M330.34,424.91c0,.18-.28,.33-.62,.33s-.62-.15-.62-.33,.28-.33,.62-.33,.62,.15,.62,.33Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "343.67 449.94 152.03 339.2 155.56 337.16 347.16 447.94 343.67 449.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "343.67 449.94 343.67 579.64 152.03 468.9 152.03 339.2 343.67 449.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "347.16 447.94 347.16 577.8 343.67 579.8 343.67 449.94 347.16 447.94"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "196.06 564.67 248.94 534.32 248.64 462.55 196.06 492.67 196.06 564.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "196.06 564.67 192.69 562.72 192.69 490.73 196.06 492.67 196.06 564.67"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "110.29 515.86 160.2 486.78 160.2 414.83 110.29 443.86 110.29 515.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "110.29 515.86 106.92 513.92 106.92 441.92 110.29 443.86 110.29 515.86"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "204.73 494.19 204.73 555.31 248.03 581.37 248.03 519.22 204.73 494.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "204.7 521.97 204.7 522.73 246.37 547.81 246.37 546.99 204.7 521.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "204.7 538.24 204.7 538.99 246.37 564.07 246.37 563.25 204.7 538.24"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "246.98 595.25 299.86 564.9 299.56 493.13 246.98 523.25 246.98 595.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "246.98 595.25 243.62 593.3 243.62 521.31 246.98 523.25 246.98 595.25"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "158.52 487.75 161.89 485.81 161.89 413.81 158.52 415.75 158.52 487.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "297.87 566.05 301.24 564.1 301.24 492.11 297.87 494.05 297.87 566.05"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "238.04 505.05 129.32 442.27 129.32 460.23 238.04 523.01 238.04 505.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "238.04 523.01 238.04 505.05 282.05 480.48 282.05 497.43 238.04 523.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "247.09 532.72 95.36 444.71 95.36 441.12 247.09 529.13 247.09 532.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "247.09 529.13 310.02 492.78 310.02 496.37 247.09 532.72 247.09 529.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "95.36 441.12 158.26 404.72 310.02 492.78 247.09 529.13 95.36 441.12"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "197.24 473.06 171.27 458.03 161.65 463.57 187.67 478.6 197.24 473.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "187.67 479.96 197.24 474.4 197.24 473.06 187.67 478.6 187.67 479.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "187.67 478.6 187.67 479.96 161.65 464.85 161.65 463.57 187.67 478.6"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "184.3 476.65 183.81 476.37 193.39 470.84 193.88 471.12 184.3 476.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "180.51 474.46 180.02 474.18 189.6 468.65 190.1 468.93 180.51 474.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "176.73 472.27 176.24 471.99 185.82 466.46 186.31 466.74 176.73 472.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "172.97 470.09 172.49 469.81 182.07 464.28 182.56 464.55 172.97 470.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "195.39 474.13 195.87 473.85 169.86 458.82 169.37 459.1 195.39 474.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "193.5 475.27 193.98 475 167.94 459.94 167.45 460.23 193.5 475.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "191.53 476.37 192.01 476.09 166.01 461.06 165.51 461.34 191.53 476.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "189.57 477.56 190.1 477.3 164 462.22 163.51 462.5 189.57 477.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "169.28 467.95 168.8 467.67 178.38 462.13 178.87 462.41 169.28 467.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "165.64 465.85 165.15 465.56 174.73 460.03 175.22 460.31 165.64 465.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M182.71,444.59l-17.21,9.94c-1.19,.68-3.28,.6-4.64-.19l-11.07-6.39c-1.37-.79-1.52-2-.33-2.68l17.21-9.94c1.19-.68,3.28-.6,4.64,.19l11.07,6.39c1.37,.79,1.52,2,.33,2.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 148.64,
    y: 445.47,
    width: 10.87,
    height: 1.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 172.63,
    y: 442.45,
    width: 10.87,
    height: 1.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.71,443.48l-17.21,9.94c-1.19,.68-3.28,.6-4.64-.19l-11.07-6.39c-1.37-.79-1.52-2-.33-2.68l17.21-9.94c1.19-.68,3.28-.6,4.64,.19l11.07,6.39c1.37,.79,1.52,2,.33,2.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "168.48 434.82 150.48 445.25 163.41 452.66 181.46 442.26 168.48 434.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M176.14,437.91c0,.18-.28,.33-.62,.33s-.62-.15-.62-.33,.28-.33,.62-.33,.62,.15,.62,.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "203.8 483.13 209.23 486.25 218.21 480.23 217.95 479.58 212.61 476.51 203.8 483.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.8,483.13l9.66-5.58s-.51-1.26-1.53-1.25c-6.69,.09-8.13,6.83-8.13,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M209.2,486.25l9.66-5.58s-.51-1.23-1.53-1.25c-6.92-.1-8.13,6.83-8.13,6.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "160.76 408.4 140.38 420.2 155.02 428.59 175.45 416.82 160.76 408.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "150.7 415.73 143.27 420.07 155.02 426.79 162.49 422.48 150.7 415.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "153.66 414.04 152.53 414.71 164.28 421.43 165.45 420.79 153.66 414.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "156.07 412.63 154.95 413.31 166.7 420.03 167.87 419.38 156.07 412.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "155.02 428.59 155.02 433.12 175.45 421.35 175.45 416.82 155.02 428.59"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.38 420.2 140.38 421.26 154.18 429.17 154.18 431.74 140.38 423.83 140.38 424.73 155.02 433.12 155.02 428.59 140.38 420.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "154.18 429.17 140.38 421.26 140.38 423.83 154.18 431.74 154.18 429.17"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "160.76 402.71 140.38 414.51 155.02 422.91 175.45 411.14 160.76 402.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "155.33 407.16 147.9 411.5 159.65 418.22 167.12 413.91 155.33 407.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "158.29 405.47 157.16 406.14 168.91 412.86 170.08 412.22 158.29 405.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "160.7 404.06 159.58 404.74 171.33 411.46 172.5 410.81 160.7 404.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "155.02 422.91 155.02 427.43 175.45 415.66 175.45 411.14 155.02 422.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "140.38 414.51 140.38 415.57 154.18 423.48 154.18 426.05 140.38 418.14 140.38 419.04 155.02 427.43 155.02 422.91 140.38 414.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "154.18 423.48 140.38 415.57 140.38 418.14 154.18 426.05 154.18 423.48"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "132.29 424.61 105.26 440.27 123.51 450.83 150.53 435.13 132.29 424.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "121.47 433.37 114 437.67 128.28 445.85 135.75 441.54 121.47 433.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "123.51 432.18 122.92 432.52 137.2 440.7 137.79 440.36 123.51 432.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "124.84 431.41 124.24 431.76 138.53 439.94 139.12 439.59 124.84 431.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "126.25 430.6 125.65 430.95 139.94 439.13 140.53 438.78 126.25 430.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "127.6 429.83 127 430.17 141.29 438.34 141.88 438 127.6 429.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "128.93 429.05 128.33 429.4 142.62 437.58 143.21 437.23 128.93 429.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "130.33 428.25 129.74 428.59 144.02 436.77 144.61 436.42 130.33 428.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "112.5 438.55 111.9 438.89 126.19 447.06 126.78 446.72 112.5 438.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "133.21 426.56 131.13 427.76 145.4 435.94 147.49 434.74 133.21 426.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "105.26 440.27 105.26 441.59 123.51 452.15 123.51 450.83 105.26 440.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "150.51 435.14 123.51 450.83 123.51 452.15 150.51 436.46 150.51 435.14"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M188.48,455.49s7.98-4.37,10.16-5.9c1.58-1.1,1.08-2.05,.12-5.19s-3.08-8.9-3.08-8.9l1.94-.31s2.26,6.94,3.07,9.6,1.15,4.54-1.27,6.06c-3.29,2.08-10.94,6.5-10.94,6.5v-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M195.92,452.18c1.77-1.09,3.74-1.75,4.35-4.12,.59-2.3-.63-4.69-1.5-6.81-1.18-2.91-1.26-5.69-2.64-8.52,6.44,.64,12.86,5.46,13.32,6.03,.48,.61,4.05,13.86,4.54,15.58,.48,1.73,0,2.75-2.98,4.53-2.97,1.78-8.81,4.5-8.81,4.5l-13.26-7.49c2.12-1.26,4.82-2.39,6.98-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M202.2,463.39s8.13-4.59,10.26-5.93c1.63-1.02,.98-2.16,.01-5.31-.97-3.14-3.08-8.9-3.08-8.9l1.94-.31s2.26,6.94,3.07,9.6c.81,2.66,1.36,4.72-1.07,6.25-3.29,2.08-11.14,6.46-11.14,6.46v-1.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "202.2 463.39 202.2 465.25 188.48 457.35 188.48 455.49 202.2 463.39"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M230.94,418.15v35.55c0,2.66-2.88,4.32-5.18,2.99l-41.83-24.15c-1.07-.62-1.73-1.76-1.73-2.99v-35.55c0-2.66,2.88-4.32,5.18-2.99l41.83,24.15c1.07,.62,1.73,1.76,1.73,2.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "229.24 456.68 226.92 458.02 224.22 455.19 229.58 451.91 229.24 456.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "183.72 391.15 181.72 392.3 185.71 392.37 183.72 391.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M228.71,419.46v35.55c0,2.66-2.88,4.32-5.18,2.99l-41.83-24.15c-1.07-.62-1.73-1.76-1.73-2.99v-35.55c0-2.66,2.88-4.32,5.18-2.99l41.83,24.15c1.07,.62,1.73,1.76,1.73,2.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "183.85 396.86 224.22 420.19 224.22 453.62 183.85 430.29 183.85 396.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "222.65 423.92 222.65 422.47 185.1 400.77 185.1 402.15 222.65 423.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "189.49 415.06 186.77 413.47 186.77 426.14 189.49 427.73 189.49 415.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "206.58 431.53 203.85 429.94 203.85 435.95 206.58 437.54 206.58 431.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "218.46 438.47 215.73 436.87 215.73 442.89 218.46 444.48 218.46 438.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "195.25 413.62 192.52 412.03 192.52 429.45 195.25 431.05 195.25 413.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "212.68 423.68 209.95 422.09 209.95 439.51 212.68 441.1 212.68 423.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "200.66 423.92 197.93 422.32 197.93 432.62 200.66 434.21 200.66 423.92"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.68,441.86l3.61,2.05c.44,.25,.82,.11,.84-.3h0c.03-.42-.31-.96-.75-1.21l-3.61-2.05c-.44-.25-.82-.11-.84,.3h0c-.03,.42,.31,.96,.75,1.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "222.65 450.56 222.65 449.11 185.1 427.42 185.1 428.8 222.65 450.56"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "231.88 542.68 217.96 534.32 217.96 536.67 231.88 545.08 231.88 542.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "231.88 525.99 217.96 517.63 217.96 519.98 231.88 528.39 231.88 525.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "231.88 558.47 217.96 550.11 217.96 552.46 231.88 560.87 231.88 558.47"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M269.59,481.25l-18.67,10.75c-.99,.57-1.01,2-.03,2.6l15.94,9.59c2.17,1.31,4.88,1.33,7.08,.06l16.8-9.72c1.52-.88,1.54-3.07,.04-3.98l-15.37-9.25c-1.78-1.07-3.99-1.09-5.79-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 250.16,
    y: 490.94,
    width: 2.59,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 287.25,
    y: 489.96,
    width: 4.61,
    height: 2.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M269.59,478.96l-18.67,10.75c-.99,.57-1.01,2-.03,2.6l15.94,9.59c2.17,1.31,4.88,1.33,7.08,.06l16.8-9.72c1.52-.88,1.54-3.07,.04-3.98l-15.37-9.25c-1.78-1.07-3.99-1.09-5.79-.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M257.92,487.85l-4.46,2.57c-.24,.14-.24,.48,0,.62l3.81,2.29c.52,.31,1.17,.32,1.69,.02l4.02-2.32c.36-.21,.37-.74,0-.95l-3.68-2.21c-.42-.26-.95-.26-1.38-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M271.38,480.03l-4.46,2.57c-.24,.14-.24,.48,0,.62l3.81,2.29c.52,.31,1.17,.32,1.69,.01l4.02-2.32c.36-.21,.37-.73,0-.95l-3.68-2.21c-.42-.26-.95-.26-1.38-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M253.27,490.62s2.31-5.61,7.88-9.2,11.29-1.52,11.29-1.52v2.9s-4.07-.26-7.23,1.9c-3.16,2.16-5.41,6.83-5.41,6.83l-6.52-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M257.33,493s2.31-5.61,7.88-9.2c5.57-3.59,11.29-1.52,11.29-1.52l-.44,.25-5.34,2.98s-2.12-1.56-4.73,.24c-3.15,2.17-2.77,4.69-2.77,4.69l-5.89,2.56Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "277.16 485.3 286.84 491.17 289.37 489.73 279.67 483.89 277.16 485.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "274.3 487.23 276 488.28 277.64 487.32 275.92 486.32 274.3 487.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "276.77 488.72 278.47 489.76 280.11 488.8 278.39 487.8 276.77 488.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "279.22 490.17 280.92 491.21 282.55 490.26 280.84 489.25 279.22 490.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "281.76 491.72 283.45 492.76 285.09 491.81 283.38 490.8 281.76 491.72"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "271.21 489.01 272.9 490.06 274.54 489.1 272.83 488.09 271.21 489.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "273.68 490.5 275.37 491.54 277.01 490.58 275.29 489.58 273.68 490.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "276.13 491.95 277.82 492.99 279.46 492.03 277.74 491.03 276.13 491.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "278.66 493.5 280.36 494.54 281.99 493.59 280.28 492.58 278.66 493.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "268.06 490.83 269.76 491.87 271.4 490.91 269.68 489.91 268.06 490.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "270.53 492.31 272.23 493.35 273.86 492.4 272.15 491.39 270.53 492.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "272.98 493.76 274.68 494.8 276.31 493.85 274.6 492.84 272.98 493.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "275.52 495.31 277.21 496.36 278.85 495.4 277.14 494.39 275.52 495.31"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "265.03 492.58 266.73 493.62 268.37 492.67 266.65 491.66 265.03 492.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "267.5 494.06 269.2 495.1 270.83 494.15 269.12 493.14 267.5 494.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "269.95 495.51 271.65 496.56 273.28 495.6 271.57 494.6 269.95 495.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "272.49 497.07 274.18 498.11 275.82 497.15 274.11 496.15 272.49 497.07"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "261.31 494.74 265.47 497.27 267.11 496.31 262.93 493.82 261.31 494.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "266.22 497.68 270.46 500.27 272.09 499.32 267.84 496.76 266.22 497.68"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M240.22,506.31h0c-2.62,0-4.58-1.99-5.45-3.69-.84-1.64-.99-3.27-.44-4.85,1.09-3.13,4.94-6.08,12.1-9.3,3.49-1.57,6.99-4.2,10.08-6.53,4.34-3.26,8.08-6.07,10.95-5.47,1.11,.23,2.01,.96,2.69,2.16l-1.14,.65c-.49-.87-1.09-1.37-1.82-1.52-2.29-.47-5.98,2.3-9.89,5.24-3.15,2.36-6.71,5.05-10.34,6.67-6.72,3.02-10.44,5.81-11.4,8.54-.43,1.24-.31,2.48,.37,3.81,.71,1.37,2.25,2.97,4.28,2.98h0c2.17,0,4.29-1.86,6.11-5.39,2.69-5.19,9.29-8.99,9.57-9.15l.65,1.14c-.06,.04-6.55,3.77-9.05,8.61-2.61,5.04-5.39,6.1-7.28,6.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M243.9,455.25c-3.03,0-5.48,1.31-5.48,2.91s2.45,2.91,5.48,2.91,5.48-1.31,5.48-2.91-2.45-2.91-5.48-2.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M242.94,451.88c-.43,0-.77-.18-.77-.41v13.89h1.55v-13.89c0,.23-.35,.41-.77,.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M242.17,449.44v2.02c0-.23,.35-.41,.77-.41s.77,.18,.77,.41v-2.02h-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M242.94,451.05c-.43,0-.77,.18-.77,.41s.35,.41,.77,.41,.77-.18,.77-.41-.35-.41-.77-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M243.72,449.44c0,.23-.35,.41-.77,.41s-.77-.18-.77-.41,.35-.41,.77-.41,.77,.18,.77,.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M248.46,453.35c-.42-.1-.71-.36-.66-.58l-3.21,13.51,1.5,.36,3.21-13.51c-.05,.22-.43,.32-.85,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M248.27,450.8l-.47,1.97c.05-.22,.43-.32,.85-.22,.42,.1,.71,.36,.66,.58l.47-1.97-1.5-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M248.65,452.55c-.42-.1-.79,0-.85,.22s.24,.48,.66,.58c.42,.1,.79,0,.85-.22s-.24-.48-.66-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.78,451.16c-.05,.22-.43,.32-.85,.22-.42-.1-.71-.36-.66-.58,.05-.22,.43-.32,.85-.22,.42,.1,.71,.36,.66,.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M238.93,453.98c-.41,.13-.79,.06-.86-.16l4.17,13.25,1.47-.46-4.17-13.25c.07,.22-.21,.5-.61,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M237.46,451.89l.61,1.93c-.07-.22,.21-.5,.61-.62,.41-.13,.79-.06,.86,.16l-.61-1.93-1.47,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M238.68,453.19c-.41,.13-.68,.41-.61,.62,.07,.22,.45,.29,.86,.16,.41-.13,.68-.41,.61-.62-.07-.22-.45-.29-.86-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.94,451.42c.07,.22-.21,.5-.61,.62s-.79,.06-.86-.16c-.07-.22,.21-.5,.61-.62,.41-.13,.79-.06,.86,.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M243.9,461.08c-3.03,0-5.48-1.31-5.48-2.91v14.42h10.96v-14.42c0,1.61-2.45,2.91-5.48,2.91Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 243.9,
    cy: 472.59,
    rx: 5.48,
    ry: 2.91
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "211.19 447.81 211.19 458.24 220.23 463.75 220.23 453.17 211.19 447.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "172.63 390.38 172.63 400.81 181.67 406.32 181.67 395.74 172.63 390.38"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "233.05 483.75 223.81 478.42 234.48 472.26 243.72 477.59 233.05 483.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "243.72 477.59 243.72 482.86 233.05 489.02 233.05 483.75 243.72 477.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "223.81 478.42 223.81 483.68 233.05 489.02 233.05 483.75 223.81 478.42"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "228.25 483.46 233.05 486.05 233.05 485.42 228.25 483.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "233.05 487.75 233.05 487.12 227.36 484.31 233.05 487.75"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M223.81,479.31l5.76,3.52-5.76-3.11v-.41Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M154.52,526.71l.83,8.16s3.85,4.12,9.2,.52c3.18-2.15,8.77-5.49,10.55-9.14,1.78-3.65,1.22-5.83-.33-6.8-1.55-.97-9.4,3.6-9.4,3.6l-10.84,3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M165.97,520.25s-4.35-25.93-5.82-30.76c-2.04-6.72-3.67-9.43-8.01-11.17-2.55-1.02-8.47-.21-14.59,1.11-.78,5.5-.03,11.71,2.92,16.43,2.08-1.12,4.13-2.24,6.06-3.3,.84,2.08,1.59,4.53,2.08,7.36,.74,4.2,1.96,10.78,2.17,15.13,.21,4.35,.61,10.78,.61,10.78,0,0,4.52,3.78,10.18,1.57,5.57-2.18,4.38-7.16,4.38-7.16Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M133.93,547.83h0c-1.98,0-3.6-1.62-3.6-3.6v-33.25c0-1.98,1.62-3.6,3.6-3.6h0c1.98,0,3.6,1.62,3.6,3.6v33.25c0,1.98-1.62,3.6-3.6,3.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 133.93,
    cy: 512.56,
    rx: 22.8,
    ry: 12.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 111.13,
    y: 510.28,
    width: 45.6,
    height: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M156.73,510.28c0,6.7-10.21,12.13-22.8,12.13s-22.8-5.43-22.8-12.13,10.21-12.13,22.8-12.13,22.8,5.43,22.8,12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.66,508.96c0,6.38-9.73,11.55-21.72,11.55s-21.72-5.17-21.72-11.55,9.73-11.56,21.72-11.56,21.72,5.17,21.72,11.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "113.36 501.54 112.21 508.96 155.66 508.96 154.5 501.54 113.36 501.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M154.8,503.37c0,6.13-9.34,11.1-20.87,11.1s-20.87-4.97-20.87-11.1,9.34-11.1,20.87-11.1,20.87,4.97,20.87,11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M154.8,503.37c0,6.13-9.34,11.1-20.87,11.1s-20.87-4.97-20.87-11.1,9.34-11.1,20.87-11.1,20.87,4.97,20.87,11.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M112.56,564.98c0,2.23-1.36,4.83-3.03,5.8-1.68,.97-3.04-.06-3.04-2.29s1.36-4.83,3.04-5.8c1.68-.97,3.03,.06,3.03,2.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "113.71 563.82 111.36 562.45 107.55 570.94 109.98 572.34 113.71 563.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M115.01,566.39c0,2.23-1.36,4.83-3.03,5.8-1.68,.97-3.03-.06-3.03-2.29s1.36-4.83,3.03-5.8,3.03,.06,3.03,2.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M107.77,563.6h0c-.7-1.21-.28-2.75,.93-3.45l47.95-27.68c1.21-.7,2.75-.28,3.45,.92h0c.7,1.21,.28,2.75-.93,3.45l-47.95,27.67c-1.21,.7-2.75,.28-3.45-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M156.64,564.53l-47.95-27.67c-1.21-.7-1.62-2.24-.93-3.45h0c.7-1.21,2.24-1.62,3.45-.92l47.95,27.68c1.21,.7,1.62,2.24,.93,3.45h0c-.7,1.21-2.24,1.62-3.45,.92Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M159.57,537.28c0,2.23-1.36,4.83-3.04,5.8-1.68,.97-3.03-.06-3.03-2.29s1.36-4.83,3.03-5.8c1.68-.97,3.04,.06,3.04,2.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "160.72 536.13 158.37 534.75 154.56 543.24 156.99 544.65 160.72 536.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M162.02,538.7c0,2.23-1.36,4.83-3.03,5.8-1.68,.97-3.03-.06-3.03-2.29s1.36-4.83,3.03-5.8c1.68-.97,3.03,.06,3.03,2.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M156.61,565.69c0,2.24-1.36,4.83-3.03,5.8-1.68,.97-3.04-.06-3.04-2.29s1.36-4.83,3.04-5.8c1.68-.97,3.03,.06,3.03,2.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "157.76 564.53 155.42 563.16 151.6 571.65 154.04 573.05 157.76 564.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M159.06,567.1c0,2.23-1.36,4.83-3.03,5.8-1.68,.97-3.03-.06-3.03-2.29s1.36-4.83,3.03-5.8c1.68-.97,3.03,.06,3.03,2.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M110.64,538.86c0,2.23-1.36,4.83-3.04,5.8s-3.03-.06-3.03-2.29,1.36-4.83,3.03-5.8c1.68-.97,3.04,.06,3.04,2.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "111.79 537.71 109.45 536.33 105.63 544.82 108.07 546.23 111.79 537.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M113.09,540.27c0,2.23-1.36,4.83-3.03,5.8-1.68,.97-3.03-.06-3.03-2.29s1.36-4.83,3.03-5.8c1.68-.97,3.03,.06,3.03,2.29Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M166.8,534.06l.83,8.16s3.85,4.12,9.2,.52c3.18-2.15,8.77-5.49,10.55-9.14,1.78-3.65,1.22-5.83-.33-6.8s-9.4,3.61-9.4,3.61l-10.84,3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M103.58,469.18s2.32,2.53,9.69-1.16c8.58-4.29,13.57-5.32,13.57-5.32l-1.39-6.47-14.24,.81-7.63,12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M123.17,434.88s-4.91-1.9-8.54,1.21c-3.63,3.12-10.45,19.62-11.65,21.85-1.2,2.23-4.46,7,.17,10.94,3.8,3.23,8.44-3.95,9.95-6.52,1.9-3.24,7.15-13.21,7.15-13.21l2.92-14.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M133.06,410.48c1.13,.79,5.51-.8,6.73,8.52,.82,6.26-.12,11.11-1.9,12.74-.74,.68-4.96,1.31-4.96,1.31l.13,6.98s-4.09,1.62-8.01,0l-3.92-1.62s1.53-2.64,1.28-7.22c-.32-5.67-2.33-13.75-.91-16.75,2.57-5.43,8.49-6.09,11.57-3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M178.25,527.6s-4.35-25.93-5.82-30.76c-2.04-6.72-3.67-9.43-8.01-11.17-6.26-2.51-32.76,6.03-32.76,6.03l-19.1,.99s-.98,7.75,4.5,11.71c5.48,3.96,18.54,7.87,27.98,2.92,4.51-2.36,9.44-5.03,13.78-7.41,.84,2.08,1.59,4.53,2.08,7.36,.74,4.2,1.96,10.78,2.17,15.13,.21,4.35,.61,10.78,.61,10.78,0,0,4.52,3.78,10.18,1.57,5.57-2.18,4.38-7.16,4.38-7.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.65,501.07c3.84-1.03,6.47-4.99,9.05-8.15,2.83-3.47,4.3-11.82,.65-15.26-.45,.02-4.44-7.01,.29-17.11,2.32-4.94-2.93-13.91-4.41-17.14-1.47-3.22-6.19-5.19-6.19-5.19l-14.3-2.13s-6.26,10.88-7.09,17.38c-.58,4.55-.12,12.95,.13,24.5,.17,7.81-4.36,12.63-1.06,16.04,5.02,5.18,16.5,8.77,22.92,7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.61,436.81s2.02,2.81,6,4.08c3.99,1.27,7.59,1.03,11.51-.91,.03-2.58-3.13-3.74-3.13-3.74,0,0-5.72,1.68-9.09-.95-4.77-3.72-5.3,1.51-5.3,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M138.14,443.42c-2.31-.22-4.71,3.98-4.47,9.23,.3,6.72,14.52,22.45,14.52,22.45,4.71,2.79,18.66-5.85,22.07-6.25,3.41-.4,7.76-3.35,9.56-5.61,1.71-2.14-4.84-5.08-8.08-3.01-2.44,1.56-1.81,3.52-3.76,3.81-8.72,1.29-16.7,3.67-16.7,3.67,0,0-8.72-23.86-13.14-24.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165,464.06s2.28-.47,3.02-.71c2.37-.78,5.13,3.6,4.18,5.03-.95,1.43-5.15,2.87-5.15,2.87l-2.06-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M137.16,442.28c-2.43-.81-5.05,5.22-4.31,11.19,.63,5.14,5.45,12.75,8.25,17.2,1.63,2.58,5.38,8.23,10.89,6.86,7.26-1.81,13.04-2.21,16.66-5.4,2.37-2.09,3.2-7.37-3.16-8.52-3.35-.61-11.8,2.61-11.8,2.61,0,0-7.59-20.97-16.52-23.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M136.86,421.46c.47-1.56,1.53-5.19,1.8-6.66,.31-1.7,.4-4.22-1.92-6.63-2.32-2.41-10.37-3.19-13.28-1.51-2.91,1.68-9.1,4.76-6.94,14.8,1.75,8.11,3.44,9.02,5.89,10.93,2.14,1.66,5.91,2.08,5.91,2.08,0,0,2.1-1.52,2.48-4.59,.12-.97,0-3.9,0-3.9,0,0-2.14-4.24-.48-5.75,1.77-1.61,3.58,.95,3.99,1.99,1.45,3.63,.74,10.46,.74,10.46,0,0,2.15,1.39,4.29,.85,1.18-.29,.14-4.85,.14-4.85,0,0-2.27-1.14-2.63-7.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123.17,506.09v-26.1c0-9.14-5.61-19.85-12.46-23.81l-6.5-3.76c-6.85-3.96-12.46,.28-12.46,9.42v26.1l31.43,18.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "95.93 451.87 90.6 455.04 95.36 458.2 95.93 451.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "117.98 509.17 123.17 506.09 117.03 500.05 117.98 509.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M117.98,509.17v-26.1c0-9.14-5.61-19.85-12.46-23.81l-6.5-3.76c-6.85-3.96-12.46,.28-12.46,9.42v26.1l31.43,18.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M98.37,480.83c0,5.53-.55,17.4-.46,20.15,.19,5.97-3.51,24.7,20.28,25.36,2.39,.07,12.11-.57,13.83-1.69-3.91-.18-10.62-1.64-15.98-4.58-15.45-1.42-13.79-13.22-13.58-20.59,.24-8.6,.03-15.61,0-18.49-.04-3.72-4.09-3.89-4.09-.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "243.33 511.97 434.97 401.24 431.44 399.2 239.84 509.98 243.33 511.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "243.33 511.97 243.33 641.67 434.97 530.93 434.97 401.24 243.33 511.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "239.84 509.98 239.84 639.83 243.33 641.83 243.33 511.97 239.84 509.98"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "397.1 445.11 397.1 470.22 375.32 483.48 375.32 458.01 397.1 445.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "429.31 429.26 429.31 439.68 420.27 445.19 420.27 434.61 429.31 429.26"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "393.31 435.38 414.12 423.3 414.12 455.62 393.31 467.65 393.31 435.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "396 437.88 411.84 428.68 411.84 430.43 396 439.59 396 437.88"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M408.28,438.34c1.54,.89,2.43,2.9,2.43,5.52,0,4.77-2.92,10.33-6.52,12.41-.09,.05-.18,.07-.27,.12v-17.84c1.58-.83,3.12-.92,4.36-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399.56,456.59c-1.54-.89-2.43-2.9-2.43-5.52,0-4.77,2.92-10.33,6.52-12.41,.09-.05,.18-.07,.27-.12v17.84c-.85,.45-1.7,.7-2.49,.7-.67,0-1.3-.16-1.87-.49Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M539.05,494.69s-.44,17.79-.44,21.8,.56,12.37-6.49,15.34c-7.04,2.97-17.02,6.87-17.02,6.87l9.45,6.08s9.53-4.14,14.42-7.16c6.89-4.25,6.17-15.85,6.17-23.22s-1.26-16.98-1.26-16.98l-4.83-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M515.1,577.39h0c-2.07,0-3.77-1.7-3.77-3.77v-34.79c0-2.07,1.7-3.77,3.77-3.77h0c2.07,0,3.77,1.7,3.77,3.77v34.79c0,2.07-1.7,3.77-3.77,3.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 515.1,
    cy: 540.49,
    rx: 23.86,
    ry: 12.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 491.25,
    y: 538.1,
    width: 47.71,
    height: 2.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 515.1,
    cy: 538.1,
    rx: 23.86,
    ry: 12.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M537.83,536.72c0,6.68-10.18,12.09-22.73,12.09s-22.73-5.41-22.73-12.09,10.18-12.09,22.73-12.09,22.73,5.41,22.73,12.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "493.58 528.96 492.37 536.72 537.83 536.72 536.62 528.96 493.58 528.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M536.94,530.88c0,6.42-9.78,11.62-21.84,11.62s-21.84-5.2-21.84-11.62,9.78-11.62,21.84-11.62,21.84,5.2,21.84,11.62Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M561.23,523.03v-26.1c0-9.14-5.61-19.85-12.46-23.81l-6.5-3.76c-6.85-3.96-12.46,.28-12.46,9.42v26.1l31.43,18.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "533.99 468.82 528.67 471.98 533.43 475.14 533.99 468.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "556.05 526.12 561.23 523.03 555.1 516.99 556.05 526.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M556.05,526.12v-26.1c0-9.14-5.61-19.85-12.46-23.81l-6.5-3.76c-6.85-3.96-12.46,.28-12.46,9.42v26.1l31.43,18.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M492.74,595.33c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "493.94 594.13 491.49 592.69 487.49 601.57 490.04 603.04 493.94 594.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M495.3,596.82c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M487.73,593.9h0c-.73-1.26-.3-2.88,.97-3.61l50.17-28.96c1.26-.73,2.88-.3,3.61,.97h0c.73,1.26,.3,2.88-.97,3.61l-50.17,28.96c-1.26,.73-2.88,.3-3.61-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M538.86,594.86l-50.17-28.96c-1.26-.73-1.7-2.35-.97-3.61h0c.73-1.26,2.35-1.7,3.61-.97l50.17,28.96c1.26,.73,1.7,2.35,.97,3.61h0c-.73,1.26-2.35,1.7-3.61,.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M541.92,566.35c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "543.13 565.15 540.68 563.71 536.68 572.59 539.23 574.06 543.13 565.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M544.49,567.84c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M538.83,596.08c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "540.03 594.87 537.58 593.43 533.59 602.31 536.14 603.78 540.03 594.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M541.4,597.56c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07,3.18,.06,3.18,2.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M490.73,568.01c0,2.34-1.42,5.05-3.18,6.07-1.75,1.01-3.18-.06-3.18-2.4s1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "491.93 566.8 489.48 565.36 485.49 574.24 488.04 575.71 491.93 566.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M493.3,569.49c0,2.34-1.42,5.06-3.18,6.07s-3.18-.06-3.18-2.4,1.42-5.05,3.18-6.07c1.75-1.01,3.18,.06,3.18,2.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M484.39,593.92s-2.28,2.48-5.32,5.44c-2.81,2.74-3.69,3.53-6.3,6.08-1.53,1.49-.27,2.86,2.64,2.75,2.56-.1,8.34-1.34,11.58-2.51,2.3-.83,6.52-3.16,8.67-4.52,2.15-1.36,2.57-3.25,2.57-3.25v-4.58l-13.85,.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M484.64,542.62c-2.59,18.31-1.44,50.14-1.44,50.14,0,0,.34,3.96,7.12,3.93,5.21-.02,9.5-4.26,9.5-4.26l.54-37.95,2.25-11.16c-5.98-.43-11.97-.66-17.97-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M502.91,605.46s-2.28,2.48-5.32,5.44c-2.81,2.74-3.69,3.53-6.3,6.08-1.53,1.49-.27,2.86,2.64,2.75,2.56-.1,8.34-1.34,11.58-2.51,2.3-.83,6.52-3.16,8.67-4.52,2.15-1.36,2.57-3.25,2.57-3.25v-4.58l-13.85,.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M503.15,554.17c-2.59,18.31-1.44,50.14-1.44,50.14,0,0,.34,3.96,7.12,3.93,5.21-.02,9.5-4.26,9.5-4.26l.54-37.95,2.25-11.16c-5.98-.43-11.97-.66-17.97-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M508.95,533.66c3.53,6.28,13.52,1.2,20.06,.76,8.87-.6,14.05,4.26,19.05,1.81,2.73-7.43,.42-15.17,0-22.73-.5-8.98,4.86-18.21,4.13-28.46-2.65-8.73-13.5-16.79-13.5-16.79l-13.86-.25s-5.07,0-8.08,3.11c-4.58,4.73-4.93,15.12-5.46,23.72-.56,8.97,1.98,19.51,1.13,27.15-.19,1.69-1.87,4.55-3.48,11.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M526.05,473.59l4.49,3.21s.94,7.18-2.35,11.19c-3.29,4.01-6.51,12.95-6.51,12.95,0,0-3.84-11.68-1.89-17,1.95-5.32,4.05-10.89,4.05-10.89l2.21,.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "522.65 476.25 523.84 480.44 526.73 481.73 530.54 479.09 527.65 474.81 522.65 476.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M524.36,479.23s-3.34,7.54-4.14,9.18c-.79,1.64,0,5.72,0,5.72l1.46,6.81s2.2-7.05,3.5-9.24c.39-3.59,1.79-11.49,1.79-11.49l-2.62-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M525.15,466.95s-2.79,.91-5,4.16c-1.36,2-2.55,3.79-2.55,3.79l3.35,2.02-3.79,1.39s-.53,5.17,.5,9.98c1.03,4.8,4.01,12.65,4.01,12.65,0,0-.6-12.97,0-16.47,1.4-8.16,4.01-11.81,4.01-11.81,0,0,2.13-4.59,1.95-4.66-.18-.08-2.49-1.05-2.49-1.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M526.39,466.03l-1.21,7.03s1.24,.55,2.47,1.76c1.67,1.63,3.72,3.83,6.33,1.59,4.52-3.88,5.17-5.66,5.17-5.66l-2.23-12.37-10.53,7.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M538.15,444.78c-3-3.82-11.61-7.04-17.22,1.27-5.88,8.71-.32,22.95,4.83,22.12,2.89-.47,9.39-3.1,12.23-7.75,3.21-5.23,2.48-12.67,.16-15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M518.4,448.99c1.13,1.97,3.89,4.21,8.73,4.65,3.96,.36,7.14-.7,7.14-.7l-1.33,9.32s1.35,.06,2.18-5.49c.6-1.99,2.39-1.8,2.96-.68,.66,1.31-.09,4.32-.09,4.32,0,0,4.72-2.66,4.94-8.73,.14-3.78-2.85-12.09-9.74-13.22-6.89-1.13-12.34,2.34-14.18,5.97-.92,1.82-1.13,3.65-.62,4.54Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "526.02 468.2 523.84 476.43 527.65 474.81 529.69 480.44 536.39 472.13 527.65 474.81 526.02 468.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M519.54,461.73c-.62,1.79,.62,6.37,3.33,7.69,2.71,1.32,7.28-1.3,9.12-3.04,.94-.89,1.95-2.6,2.5-6.6,.37-2.68-.69-2.4-1.09-.76-1.41,5.9-4.86,6.77-6.84,7.36-3.46,1.04-5.32-.72-7.02-4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M538.26,465.81s-4.06,8.19-5.91,10.63c-1.85,2.43-6.35,9.91-8.42,14.53-1,2.23-2.25,9.97-2.25,9.97,0,0,1.76-3.34,7.3-9.06,3.44-3.55,6.75-6.18,6.75-6.18l-2.49-4.4,5.46,1.72s2.16-3.05,2.63-5.73c.5-2.92,.69-5.51,.4-6.52-.91-3.1-3.46-4.96-3.46-4.96Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "382.99 583.48 433.48 554.1 433.48 482.1 382.99 511.48 382.99 583.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "382.99 583.48 379.63 581.53 379.63 509.54 382.99 511.48 382.99 583.48"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "431.23 555.37 434.6 553.42 434.6 481.43 431.23 483.37 431.23 555.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "382.99 550.37 516.32 627.47 516.32 596.69 382.99 519.08 382.99 550.37"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "519.69 662.86 572.27 632.69 572.27 560.69 519.69 590.87 519.69 662.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "519.69 662.86 516.32 660.92 516.32 588.92 519.69 590.87 519.69 662.86"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "570.58 633.66 573.95 631.72 573.95 559.72 570.58 561.67 570.58 633.66"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "519.8 600.34 368.07 512.33 368.07 508.73 519.8 596.75 519.8 600.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "519.8 596.75 582.73 560.39 582.73 563.77 519.8 600.12 519.8 596.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "368.07 508.73 430.97 472.34 582.73 560.39 519.8 596.75 368.07 508.73"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M521.61,468.48c-.4-.55-3.47-3.16-8.01,1.3-6.2,6.1-11.07,15.92-16.38,20.1-1.24,.97-22.58,11.9-22.58,11.9l4.59,9.49s13.08-6.87,18-9.08c5.67-2.55,11.81-6.06,14.23-9.88,.48-20.24,10.16-23.82,10.16-23.82Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "500.15 527.59 474.18 512.56 464.56 518.1 490.58 533.13 500.15 527.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "490.58 534.49 500.15 528.94 500.15 527.59 490.58 533.13 490.58 534.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "490.58 533.13 490.58 534.49 464.56 519.38 464.56 518.1 490.58 533.13"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "487.21 531.19 486.72 530.91 496.3 525.37 496.8 525.65 487.21 531.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "483.42 529 482.94 528.72 492.52 523.18 493.01 523.46 483.42 529"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "479.64 526.81 479.15 526.53 488.73 520.99 489.23 521.27 479.64 526.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "475.89 524.63 475.4 524.34 484.98 518.81 485.47 519.09 475.89 524.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "498.3 528.66 498.79 528.38 472.77 513.35 472.28 513.63 498.3 528.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "496.41 529.81 496.89 529.53 470.85 514.48 470.36 514.76 496.41 529.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "494.44 530.91 494.93 530.62 468.92 515.59 468.42 515.87 494.44 530.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "492.48 532.09 493.01 531.83 466.91 516.75 466.42 517.03 492.48 532.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "472.2 522.48 471.71 522.2 481.29 516.67 481.78 516.95 472.2 522.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "468.55 520.38 468.06 520.1 477.64 514.56 478.13 514.84 468.55 520.38"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M516.35,518.91c-3.78,1.13-7.27,1.9-11.23,3.15-3.59,1.13-7.1,3.86-6.67,7.29,.75,5.95,15.82,1.43,17.93-.13,1.12-.82,5.64-3.23,5.64-3.23,0,0-.71-3.7-5.67-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M548.29,477.93c-7.3,.82-10.59,32.69-10.59,32.69,0,0-15.65,4.21-23.47,7.24,7.1,4.91,4.83,11.14,4.83,11.14,0,0,6.2-1.39,13.92-3.17,6.57-1.52,11.33-3.05,13.65-6.77,2.32-3.72,3.24-5.2,4.22-12.15,1.05-7.43,7.16-18.33-2.56-28.97Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "469.46 541.42 457.32 534.41 452.79 541.42 459.9 547.6 469.46 541.42"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M484.45,499.56v35.55c0,2.66-2.88,4.32-5.18,2.99l-41.83-24.15c-1.07-.62-1.73-1.76-1.73-2.99v-35.55c0-2.66,2.88-4.32,5.18-2.99l41.83,24.15c1.07,.62,1.73,1.76,1.73,2.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "482.75 538.1 480.43 539.43 477.73 536.61 483.09 533.33 482.75 538.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "437.23 472.56 435.23 473.72 439.22 473.79 437.23 472.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M482.22,500.87v35.55c0,2.66-2.88,4.32-5.18,2.99l-41.83-24.15c-1.07-.62-1.73-1.76-1.73-2.99v-35.55c0-2.66,2.88-4.32,5.18-2.99l41.83,24.15c1.07,.62,1.73,1.76,1.73,2.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "449.4 511.87 449.4 543.29 458.97 548.84 458.97 517.43 449.4 511.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "449.4 511.87 450.66 511.17 460.23 516.73 458.97 517.43 449.4 511.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "460.23 516.73 458.97 517.43 458.97 548.84 460.23 548.14 460.23 516.73"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "459.9 548.32 469.46 542.77 469.46 541.42 459.9 546.96 459.9 548.32"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M504.05,554.47l-17.21,9.94c-1.19,.68-3.28,.6-4.64-.19l-11.07-6.39c-1.37-.79-1.52-2-.33-2.68l17.21-9.94c1.19-.68,3.28-.6,4.64,.19l11.07,6.39c1.37,.79,1.52,2,.33,2.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 469.99,
    y: 555.36,
    width: 10.87,
    height: 1.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 493.98,
    y: 552.33,
    width: 10.87,
    height: 1.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M504.05,553.37l-17.21,9.94c-1.19,.68-3.28,.6-4.64-.19l-11.07-6.39c-1.37-.79-1.52-2-.33-2.68l17.21-9.94c1.19-.68,3.28-.6,4.64,.19l11.07,6.39c1.37,.79,1.52,2,.33,2.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "489.83 544.71 471.83 555.13 484.76 562.55 502.81 552.15 489.83 544.71"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 496.87,
    cy: 547.79,
    rx: 0.62,
    ry: 0.33
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526.26,538.94l-5.34-3.08h0c-.19-.12-.42-.2-.68-.2-3.84,0-8.13,6.83-8.13,6.83l5.43,3.11,8.99-6.02-.26-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M517.52,545.6l9.66-5.58s-.51-1.25-1.53-1.25c-3.84,0-8.13,6.83-8.13,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M514.2,543.69l.57,.33s.72-1.14,1.83-2.49l-.58-.32c-1.1,1.35-1.82,2.49-1.82,2.49Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "557.89 568.86 534.8 555.58 496.6 577.58 519.69 590.87 557.89 568.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M516.34,550.58c-12.23,7.06-21.41,12.34-21.41,12.34v13.65l38.2-22s-7.82-9.17-16.79-3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M518.02,551.59c-12.23,7.06-21.41,12.34-21.41,12.34v13.66l38.2-22s-7.82-9.17-16.79-3.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "528.32 556.5 501.29 572.16 519.53 582.71 546.55 567.02 528.32 556.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "517.49 565.25 510.03 569.56 524.3 577.74 531.78 573.43 517.49 565.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "519.53 564.07 518.94 564.41 533.23 572.59 533.82 572.25 519.53 564.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "520.86 563.3 520.27 563.64 534.56 571.83 535.15 571.48 520.86 563.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "508.52 570.43 507.93 570.77 522.22 578.95 522.81 578.61 508.52 570.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "506.9 571.37 504.82 572.57 519.1 580.75 521.19 579.54 506.9 571.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "501.29 572.16 501.29 573.48 519.53 584.04 519.53 582.71 501.29 572.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "546.53 567.03 519.53 582.71 519.53 584.04 546.53 568.35 546.53 567.03"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M539.43,563.86c-12.23,7.06-21.41,12.34-21.41,12.34v13.66l38.2-22s-7.82-9.17-16.79-3.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "494.93 562.92 494.93 576.49 519.69 590.87 519.69 577.21 494.93 562.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M541.11,564.87c-12.23,7.06-21.41,12.34-21.41,12.34v13.65l38.2-22s-7.82-9.17-16.79-3.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "494.93 562.92 519.69 577.21 519.71 575.21 496.67 561.89 494.93 562.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "399.43 479.79 399.43 495.66 387.92 485.95 399.43 479.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "411.2 487.97 411.2 503.85 399.69 494.13 411.2 487.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M402.29,495.13l-1.73-1,10.64-6.16-1.05-.61-11.72,6.77,2.88,1.68c.32-.24,.65-.46,.98-.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "390.51 477.98 390.51 512.81 412.12 500.35 412.12 465.67 390.51 477.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "391.98 478.84 391.98 513.66 413.6 501.2 413.6 466.52 391.98 478.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "393.68 479.94 393.68 514.76 415.29 502.3 415.29 467.62 393.68 479.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "394.36 490.45 386.66 485.95 386.66 511.45 394.36 516.07 394.36 490.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "394.36 509.67 386.66 505.02 386.66 507.73 394.36 512.39 394.36 509.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M416.79,491.19l-10.66,6.16-1.92-1.11c-.36,.21-.72,.42-1.06,.65l2.98,1.74,11.76-6.79-1.1-.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "394.36 490.45 394.36 516.07 417.89 502.53 417.89 491.84 406.13 498.63 406.12 483.65 394.36 490.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "405.02 483.01 394.36 489.16 388.79 485.94 390.51 484.95 390.51 483.73 386.66 485.95 394.36 490.45 406.12 483.65 405.02 483.01"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "411.58 487.12 411.58 502.99 400.07 493.28 411.58 487.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "423.35 495.31 423.35 511.18 411.84 501.47 423.35 495.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M414.44,502.46l-1.73-1,10.64-6.16-1.05-.61-11.72,6.77,2.88,1.68c.32-.24,.65-.46,.98-.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "402.66 485.32 402.66 520.14 424.27 507.68 424.27 473 402.66 485.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "404.13 486.17 404.13 521 425.75 508.53 425.75 473.85 404.13 486.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "405.82 487.27 405.82 522.1 427.44 509.64 427.44 474.95 405.82 487.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "406.5 497.78 398.81 493.28 398.81 518.78 406.5 523.4 406.5 497.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "406.5 517.01 398.81 512.36 398.81 515.07 406.5 519.72 406.5 517.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.94,498.53l-10.66,6.16-1.92-1.11c-.36,.21-.72,.42-1.06,.65l2.98,1.74,11.76-6.79-1.1-.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "406.5 497.78 406.5 523.4 430.04 509.86 430.04 499.17 418.28 505.97 418.27 490.99 406.5 497.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "417.17 490.34 406.51 496.5 400.94 493.28 402.66 492.28 402.66 491.06 398.81 493.28 406.51 497.78 418.27 490.99 417.17 490.34"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M425.75,509.47c-3.03,0-5.48,1.3-5.48,2.91s2.45,2.91,5.48,2.91,5.48-1.31,5.48-2.91-2.45-2.91-5.48-2.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M424.79,506.1c-.43,0-.77-.18-.77-.41v13.89h1.55v-13.89c0,.23-.35,.41-.77,.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M424.02,503.67v2.02c0-.23,.35-.41,.77-.41s.77,.18,.77,.41v-2.02h-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M424.79,505.28c-.43,0-.77,.18-.77,.41s.35,.41,.77,.41,.77-.18,.77-.41-.35-.41-.77-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M425.56,503.67c0,.23-.35,.41-.77,.41s-.77-.18-.77-.41,.35-.41,.77-.41,.77,.18,.77,.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M430.31,507.57c-.42-.1-.71-.36-.66-.58l-3.21,13.51,1.5,.36,3.21-13.51c-.05,.22-.43,.32-.85,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M430.12,505.02l-.47,1.97c.05-.22,.43-.32,.85-.22,.42,.1,.71,.36,.66,.58l.47-1.97-1.5-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M430.5,506.77c-.42-.1-.79,0-.85,.22-.05,.22,.24,.48,.66,.58,.42,.1,.79,0,.85-.22,.05-.22-.24-.48-.66-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M431.62,505.38c-.05,.22-.43,.32-.85,.22-.42-.1-.71-.36-.66-.58,.05-.22,.43-.32,.85-.22,.42,.1,.71,.36,.66,.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M420.78,508.2c-.41,.13-.79,.06-.86-.16l4.17,13.25,1.47-.46-4.17-13.25c.07,.22-.21,.5-.61,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M419.31,506.11l.61,1.93c-.07-.22,.21-.5,.61-.62,.41-.13,.79-.06,.86,.16l-.61-1.93-1.47,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M420.53,507.41c-.41,.13-.68,.41-.61,.62,.07,.22,.45,.29,.86,.16s.68-.41,.61-.62c-.07-.22-.45-.29-.86-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M420.78,505.64c.07,.22-.21,.5-.61,.62-.41,.13-.79,.06-.86-.16-.07-.22,.21-.5,.61-.62s.79-.06,.86,.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M425.75,515.3c-3.03,0-5.48-1.31-5.48-2.91v14.42h10.96v-14.42c0,1.61-2.45,2.91-5.48,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M431.23,526.81c0,1.61-2.45,2.91-5.48,2.91s-5.48-1.31-5.48-2.91,2.45-2.91,5.48-2.91,5.48,1.3,5.48,2.91Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M553.37,550.96l-9.7,5.6c-.48,.28-1.32,.24-1.88-.08l-4.7-2.72c-.56-.32-.62-.81-.13-1.08l9.7-5.6c.48-.28,1.32-.24,1.88,.08l4.7,2.72c.56,.32,.62,.81,.13,1.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 536.63,
    y: 552.16,
    width: 1.03,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 550.94,
    y: 549.49,
    width: 2.74,
    height: 1.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M553.37,549.93l-9.7,5.6c-.48,.28-1.32,.24-1.88-.08l-4.7-2.72c-.56-.32-.62-.81-.13-1.08l9.7-5.6c.48-.28,1.32-.24,1.88,.08l4.7,2.72c.56,.32,.62,.81,.13,1.08Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "537.81 552.02 542.69 554.96 551.32 549.97 546.44 547.03 537.81 552.02"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 549.68,
    cy: 547.99,
    rx: 0.62,
    ry: 0.33
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "538.74 562.72 347.1 451.98 350.63 449.94 542.23 560.72 538.74 562.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "538.74 562.72 538.74 692.41 347.1 581.68 347.1 451.98 538.74 562.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "542.23 560.72 542.23 690.58 538.74 692.58 538.74 562.72 542.23 560.72"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "391.13 677.45 444.01 647.1 443.71 575.33 391.13 605.45 391.13 677.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "391.13 677.45 387.77 675.5 387.77 603.51 391.13 605.45 391.13 677.45"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "305.36 628.64 355.27 599.56 355.27 527.61 305.36 556.64 305.36 628.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "305.36 628.64 301.99 626.69 301.99 554.7 305.36 556.64 305.36 628.64"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "399.8 606.97 399.8 668.09 443.1 694.15 443.1 632 399.8 606.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "399.77 634.75 399.77 635.5 441.45 660.59 441.45 659.77 399.77 634.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "399.77 651.01 399.77 651.77 441.45 676.85 441.45 676.03 399.77 651.01"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "442.05 708.02 494.93 677.68 494.63 605.91 442.05 636.03 442.05 708.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "442.05 708.02 438.69 706.08 438.69 634.08 442.05 636.03 442.05 708.02"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "353.59 600.53 356.96 598.58 356.96 526.59 353.59 528.53 353.59 600.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "492.94 678.82 496.31 676.88 496.31 604.88 492.94 606.83 492.94 678.82"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "433.12 617.82 324.39 555.05 324.39 573.01 433.12 635.79 433.12 617.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "433.12 635.79 433.12 617.82 477.12 593.26 477.12 610.21 433.12 635.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "442.17 645.5 290.43 557.49 290.43 553.89 442.17 641.91 442.17 645.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "442.17 641.91 505.09 605.56 505.09 609.15 442.17 645.5 442.17 641.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "290.43 553.89 353.33 517.5 505.09 605.56 442.17 641.91 290.43 553.89"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "392.31 585.84 366.34 570.81 356.72 576.35 382.74 591.37 392.31 585.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "382.74 592.74 392.31 587.18 392.31 585.84 382.74 591.37 382.74 592.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "382.74 591.37 382.74 592.74 356.72 577.63 356.72 576.35 382.74 591.37"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "379.37 589.43 378.88 589.15 388.46 583.62 388.96 583.89 379.37 589.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "375.58 587.24 375.09 586.96 384.67 581.43 385.17 581.7 375.58 587.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "371.8 585.05 371.31 584.77 380.89 579.24 381.38 579.51 371.8 585.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "368.05 582.87 367.56 582.59 377.14 577.05 377.63 577.33 368.05 582.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "390.46 586.91 390.94 586.62 364.93 571.6 364.44 571.87 390.46 586.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "388.57 588.05 389.05 587.78 363.01 572.72 362.52 573.01 388.57 588.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "386.6 589.15 387.08 588.87 361.08 573.84 360.58 574.12 386.6 589.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "384.64 590.33 385.17 590.08 359.07 574.99 358.58 575.27 384.64 590.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "364.36 580.73 363.87 580.45 373.45 574.91 373.94 575.19 364.36 580.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "360.71 578.62 360.22 578.34 369.8 572.81 370.29 573.09 360.71 578.62"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M377.78,557.36l-17.21,9.94c-1.19,.68-3.28,.6-4.64-.19l-11.07-6.39c-1.37-.79-1.52-2-.33-2.68l17.21-9.94c1.19-.68,3.28-.6,4.64,.19l11.07,6.39c1.37,.79,1.52,2,.33,2.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 343.71,
    y: 558.25,
    width: 10.87,
    height: 1.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 367.7,
    y: 555.23,
    width: 10.87,
    height: 1.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.78,556.26l-17.21,9.94c-1.19,.68-3.28,.6-4.64-.19l-11.07-6.39c-1.37-.79-1.52-2-.33-2.68l17.21-9.94c1.19-.68,3.28-.6,4.64,.19l11.07,6.39c1.37,.79,1.52,2,.33,2.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "363.55 547.6 345.55 558.03 358.49 565.44 376.53 555.04 363.55 547.6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 370.59,
    cy: 550.69,
    rx: 0.62,
    ry: 0.33
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "396.65 588.76 402.07 591.88 411.06 585.86 410.8 585.21 405.46 582.14 396.65 588.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.65,588.76l9.66-5.58s-.51-1.26-1.53-1.25c-6.69,.09-8.13,6.83-8.13,6.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M402.05,591.88l9.66-5.58s-.51-1.23-1.53-1.25c-6.92-.1-8.13,6.83-8.13,6.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "425.85 582.47 398.82 598.13 417.06 608.69 444.08 592.99 425.85 582.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "415.02 591.22 407.56 595.53 421.83 603.71 429.31 599.4 415.02 591.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "417.07 590.04 416.47 590.38 430.76 598.56 431.35 598.22 417.07 590.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "418.4 589.27 417.8 589.62 432.09 597.8 432.68 597.45 418.4 589.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "419.8 588.46 419.21 588.81 433.49 596.99 434.09 596.64 419.8 588.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "421.15 587.69 420.56 588.02 434.85 596.2 435.44 595.86 421.15 587.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "422.48 586.91 421.89 587.26 436.17 595.44 436.77 595.09 422.48 586.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "423.89 586.1 423.3 586.45 437.58 594.63 438.17 594.28 423.89 586.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "406.05 596.41 405.46 596.75 419.75 604.92 420.34 604.58 406.05 596.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "426.76 584.42 424.68 585.62 438.96 593.8 441.05 592.6 426.76 584.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "398.82 598.13 398.82 599.45 417.06 610.01 417.06 608.69 398.82 598.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "444.07 593 417.06 608.69 417.06 610.01 444.07 594.32 444.07 593"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "340.04 508.48 332.34 504.18 332.34 536.84 340.04 541.29 340.04 508.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "337.69 513.92 334.68 512.24 334.68 529.74 337.69 531.48 337.69 513.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "340.04 510.18 332.34 505.89 332.34 508.24 340.04 512.58 340.04 510.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M337.69,535.52c0,1.11-.67,1.62-1.5,1.14-.83-.48-1.51-1.77-1.51-2.88s.67-1.62,1.51-1.14c.83,.48,1.5,1.77,1.5,2.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "340.04 508.48 340.04 541.29 364.56 527.17 364.56 494.32 340.04 508.48"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "363.41 493.66 339.86 507.26 334.47 504.15 357.85 490.48 357.09 490.05 332.34 504.18 340.04 508.48 364.56 494.32 363.41 493.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "339.86 507.26 363.41 493.66 357.85 490.48 334.47 504.15 339.86 507.26"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "352.3 515.67 344.61 511.37 344.61 544.02 352.3 548.47 352.3 515.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "349.96 521.1 346.95 519.42 346.95 536.93 349.96 538.67 349.96 521.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "352.3 517.37 344.61 513.08 344.61 515.42 352.3 519.77 352.3 517.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M349.96,542.7c0,1.11-.67,1.62-1.51,1.14-.83-.48-1.51-1.77-1.51-2.88s.67-1.62,1.51-1.14c.83,.48,1.51,1.77,1.51,2.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "352.3 515.67 352.3 548.47 376.83 534.35 376.83 501.51 352.3 515.67"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "375.68 500.85 352.13 514.45 346.74 511.33 370.11 497.67 369.36 497.23 344.61 511.37 352.3 515.67 376.83 501.51 375.68 500.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "352.13 514.45 375.68 500.85 370.11 497.67 346.74 511.33 352.13 514.45"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M383.55,568.27s7.98-4.37,10.16-5.9c1.58-1.1,1.08-2.05,.12-5.19-.97-3.14-3.08-8.9-3.08-8.9l1.94-.31s2.26,6.94,3.07,9.6,1.15,4.54-1.27,6.06c-3.29,2.08-10.94,6.5-10.94,6.5v-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M390.99,564.96c1.77-1.09,3.74-1.75,4.35-4.12,.59-2.3-.63-4.69-1.5-6.81-1.18-2.91-1.26-5.69-2.64-8.52,6.44,.64,12.87,5.46,13.32,6.03,.48,.61,4.05,13.85,4.54,15.58,.48,1.73,0,2.75-2.98,4.53-2.97,1.78-8.81,4.5-8.81,4.5l-13.26-7.49c2.12-1.26,4.82-2.39,6.98-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M397.27,576.17s8.13-4.59,10.26-5.93c1.63-1.02,.98-2.16,.01-5.31-.97-3.14-3.08-8.9-3.08-8.9l1.94-.31s2.26,6.94,3.07,9.6c.81,2.66,1.36,4.72-1.07,6.25-3.29,2.08-11.14,6.46-11.14,6.46v-1.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "397.27 576.17 397.27 578.02 383.55 570.12 383.55 568.27 397.27 576.17"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M426.01,530.93v35.55c0,2.66-2.88,4.32-5.18,2.99l-41.83-24.15c-1.07-.62-1.73-1.76-1.73-2.99v-35.55c0-2.66,2.88-4.32,5.18-2.99l41.83,24.15c1.07,.62,1.73,1.76,1.73,2.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "424.31 569.46 421.99 570.8 419.29 567.97 424.65 564.69 424.31 569.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "378.79 503.93 376.79 505.08 380.78 505.15 378.79 503.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M423.78,532.23v35.55c0,2.66-2.88,4.32-5.18,2.99l-41.83-24.15c-1.07-.62-1.73-1.76-1.73-2.99v-35.55c0-2.66,2.88-4.32,5.18-2.99l41.83,24.15c1.07,.62,1.73,1.76,1.73,2.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "378.92 509.67 419.29 533 419.29 566.44 378.92 543.1 378.92 509.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M393.75,554.64l3.61,2.05c.44,.25,.82,.11,.84-.3h0c.03-.42-.31-.96-.75-1.21l-3.61-2.05c-.44-.25-.82-.11-.84,.3h0c-.03,.42,.31,.96,.75,1.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "417.72 563.34 417.72 561.89 380.17 540.19 380.17 541.57 417.72 563.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "417.72 536.73 417.72 535.28 380.17 513.59 380.17 514.97 417.72 536.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M417.6,539.5v20.04l-37.31-21.62v-19.97l37.31,21.56Zm-5.23,16.2l4.54,2.62v-3.99l-4.54-2.63v4Zm0-4.81l4.54,2.62v-3.99l-4.54-2.63v4Zm0-4.81l4.54,2.62v-3.99l-4.54-2.63v4Zm0-4.81l4.54,2.62v-3.99l-4.54-2.63v4Zm-5.23,11.39l4.54,2.62v-4l-4.54-2.63v4.01Zm0-4.81l4.54,2.62v-4l-4.54-2.63v4.01Zm0-4.81l4.54,2.62v-4l-4.54-2.63v4.01Zm0-4.81l4.54,2.62v-4l-4.54-2.63v4.01Zm-5.23,11.39l4.54,2.62v-4.01l-4.54-2.63v4.02Zm0-4.81l4.54,2.62v-4.01l-4.54-2.63v4.02Zm0-4.81l4.54,2.62v-4.01l-4.54-2.63v4.02Zm0-4.81l4.54,2.62v-4.01l-4.54-2.63v4.02Zm-5.23,11.39l4.54,2.62v-4.02l-4.54-2.63v4.03Zm0-4.81l4.54,2.62v-4.02l-4.54-2.63v4.03Zm0-4.81l4.54,2.62v-4.02l-4.54-2.63v4.03Zm0-4.81l4.54,2.62v-4.02l-4.54-2.63v4.03Zm-5.23,11.39l4.54,2.62v-4.03l-4.54-2.63v4.04Zm0-4.81l4.54,2.62v-4.03l-4.54-2.63v4.04Zm0-4.81l4.54,2.62v-4.03l-4.54-2.63v4.04Zm0-4.81l4.54,2.62v-4.03l-4.54-2.63v4.04Zm-5.23,11.39l4.54,2.62v-4.04l-4.54-2.63v4.05Zm0-4.81l4.54,2.62v-4.04l-4.54-2.63v4.05Zm0-4.81l4.54,2.62v-4.04l-4.54-2.63v4.05Zm0-4.81l4.54,2.62v-4.04l-4.54-2.63v4.05Zm-5.23,11.39l4.54,2.62v-4.05l-4.54-2.63v4.05Zm0-4.81l4.54,2.62v-4.05l-4.54-2.63v4.05Zm0-4.81l4.54,2.62v-4.05l-4.54-2.63v4.05Zm0-4.81l4.54,2.62v-4.05l-4.54-2.63v4.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "416.09 540.4 416.09 542.65 413.06 540.89 413.06 538.64 416.09 540.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "410.79 542.13 410.79 544.38 407.76 542.62 407.76 540.37 410.79 542.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "405.64 543.91 405.64 546.16 402.61 544.4 402.61 542.15 405.64 543.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "400.46 545.69 400.46 547.94 397.43 546.18 397.43 543.93 400.46 545.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "400.46 531.36 400.46 533.61 397.43 531.85 397.43 529.6 400.46 531.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "395.16 533.1 395.16 535.34 392.13 533.58 392.13 531.34 395.16 533.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "390.01 534.87 390.01 537.12 386.98 535.36 386.98 533.12 390.01 534.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "384.83 536.65 384.83 538.9 381.8 537.14 381.8 534.89 384.83 536.65"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "426.95 655.46 413.03 647.1 413.03 649.45 426.95 657.86 426.95 655.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "426.95 638.77 413.03 630.41 413.03 632.76 426.95 641.17 426.95 638.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "426.95 671.25 413.03 662.89 413.03 665.24 426.95 673.65 426.95 671.25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M464.66,594.03l-18.67,10.75c-.99,.57-1.01,2-.02,2.6l15.94,9.59c2.17,1.31,4.88,1.33,7.08,.06l16.8-9.72c1.52-.88,1.54-3.07,.03-3.98l-15.37-9.25c-1.78-1.07-3.99-1.09-5.79-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 445.23,
    y: 603.72,
    width: 2.59,
    height: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 482.32,
    y: 602.74,
    width: 4.61,
    height: 2.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M464.66,591.74l-18.67,10.75c-.99,.57-1.01,2-.02,2.6l15.94,9.59c2.17,1.31,4.88,1.33,7.08,.06l16.8-9.72c1.52-.88,1.54-3.07,.03-3.98l-15.37-9.25c-1.78-1.07-3.99-1.09-5.79-.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M452.99,600.62l-4.46,2.57c-.24,.14-.24,.48,0,.62l3.81,2.29c.52,.31,1.17,.32,1.69,.02l4.02-2.32c.36-.21,.37-.73,0-.95l-3.68-2.21c-.42-.26-.95-.26-1.38-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M466.45,592.81l-4.46,2.57c-.24,.14-.24,.48,0,.62l3.81,2.29c.52,.31,1.17,.32,1.69,.01l4.02-2.32c.36-.21,.37-.74,0-.95l-3.68-2.21c-.42-.26-.95-.26-1.38-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M448.34,603.39s2.31-5.61,7.88-9.2c5.57-3.59,11.29-1.52,11.29-1.52v2.9s-4.07-.26-7.23,1.9-5.41,6.83-5.41,6.83l-6.52-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M452.4,605.78s2.31-5.61,7.88-9.2c5.57-3.59,11.29-1.52,11.29-1.52l-.44,.25-5.34,2.98s-2.12-1.56-4.73,.24c-3.15,2.17-2.77,4.69-2.77,4.69l-5.89,2.56Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "472.23 598.08 481.91 603.95 484.44 602.51 474.74 596.67 472.23 598.08"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "469.38 600.01 471.07 601.05 472.71 600.1 470.99 599.09 469.38 600.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "471.84 601.49 473.54 602.54 475.18 601.58 473.46 600.58 471.84 601.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "474.29 602.95 475.99 603.99 477.63 603.03 475.91 602.03 474.29 602.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "476.83 604.5 478.52 605.54 480.16 604.58 478.45 603.58 476.83 604.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "466.28 601.79 467.97 602.83 469.61 601.88 467.9 600.87 466.28 601.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "468.75 603.27 470.44 604.32 472.08 603.36 470.37 602.36 468.75 603.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "471.2 604.73 472.89 605.77 474.53 604.81 472.82 603.81 471.2 604.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "473.73 606.28 475.43 607.32 477.07 606.36 475.35 605.36 473.73 606.28"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "463.14 603.61 464.83 604.65 466.47 603.69 464.75 602.69 463.14 603.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "465.6 605.09 467.3 606.13 468.94 605.17 467.22 604.17 465.6 605.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "468.05 606.54 469.75 607.58 471.39 606.63 469.67 605.62 468.05 606.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "470.59 608.09 472.28 609.13 473.92 608.18 472.21 607.17 470.59 608.09"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "460.1 605.36 461.8 606.4 463.44 605.44 461.72 604.44 460.1 605.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "462.57 606.84 464.27 607.88 465.91 606.93 464.19 605.92 462.57 606.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "465.02 608.29 466.72 609.33 468.36 608.38 466.64 607.37 465.02 608.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "467.56 609.84 469.25 610.89 470.89 609.93 469.18 608.93 467.56 609.84"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "456.38 607.52 460.54 610.05 462.18 609.09 458 606.6 456.38 607.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "461.3 610.46 465.53 613.05 467.16 612.09 462.91 609.54 461.3 610.46"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M435.3,619.09h0c-2.62,0-4.58-1.99-5.45-3.69-.84-1.64-.99-3.27-.44-4.84,1.09-3.13,4.94-6.08,12.1-9.3,3.49-1.57,6.99-4.2,10.08-6.53,4.34-3.26,8.08-6.07,10.95-5.47,1.11,.23,2.01,.96,2.69,2.16l-1.14,.65c-.49-.87-1.09-1.37-1.82-1.52-2.29-.47-5.98,2.3-9.89,5.24-3.15,2.36-6.71,5.05-10.34,6.67-6.72,3.02-10.44,5.81-11.4,8.54-.43,1.24-.31,2.48,.37,3.81,.71,1.37,2.25,2.97,4.28,2.98h0c2.17,0,4.29-1.86,6.11-5.39,2.69-5.19,9.29-8.99,9.57-9.15l.65,1.14c-.06,.04-6.55,3.77-9.05,8.61-2.61,5.04-5.39,6.1-7.28,6.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 438.46,
    cy: 566.02,
    rx: 5.48,
    ry: 2.91
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M437.5,559.73c-.43,0-.77-.18-.77-.41v13.89h1.55v-13.89c0,.23-.35,.41-.77,.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M436.73,557.3v2.02c0-.23,.35-.41,.77-.41s.77,.18,.77,.41v-2.02h-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M437.5,558.91c-.43,0-.77,.18-.77,.41s.35,.41,.77,.41,.77-.18,.77-.41-.35-.41-.77-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M438.27,557.3c0,.23-.35,.41-.77,.41s-.77-.18-.77-.41,.35-.41,.77-.41,.77,.18,.77,.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M443.02,561.2c-.42-.1-.71-.36-.66-.58l-3.21,13.51,1.5,.36,3.21-13.51c-.05,.22-.43,.32-.85,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M442.83,558.66l-.47,1.97c.05-.22,.43-.32,.85-.22,.42,.1,.71,.36,.66,.58l.47-1.97-1.5-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M443.21,560.4c-.42-.1-.79,0-.85,.22s.24,.48,.66,.58c.42,.1,.79,0,.85-.22,.05-.22-.24-.48-.66-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M444.33,559.01c-.05,.22-.43,.32-.85,.22-.42-.1-.71-.36-.66-.58,.05-.22,.43-.32,.85-.22s.71,.36,.66,.58Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M433.48,561.83c-.41,.13-.79,.06-.86-.16l4.17,13.25,1.47-.46-4.17-13.25c.07,.22-.21,.5-.61,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M432.02,559.74l.61,1.93c-.07-.22,.21-.5,.61-.62,.41-.13,.79-.06,.86,.16l-.61-1.93-1.47,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M433.24,561.05c-.41,.13-.68,.41-.61,.62s.45,.29,.86,.16c.41-.13,.68-.41,.61-.62-.07-.22-.45-.29-.86-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M433.49,559.28c.07,.22-.21,.5-.61,.62s-.79,.06-.86-.16c-.07-.22,.21-.5,.61-.62s.79-.06,.86,.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M438.46,568.94c-3.03,0-5.48-1.31-5.48-2.91v14.42h10.96v-14.42c0,1.61-2.45,2.91-5.48,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M443.94,580.44c0,1.61-2.45,2.91-5.48,2.91s-5.48-1.3-5.48-2.91,2.45-2.91,5.48-2.91,5.48,1.31,5.48,2.91Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "406.26 560.59 406.26 571.02 415.3 576.53 415.3 565.95 406.26 560.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "378.47 545.55 378.47 555.98 387.52 561.49 387.52 550.91 378.47 545.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "421.49 536.25 421.49 546.68 430.54 552.19 430.54 541.61 421.49 536.25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "448.42 588.15 439.18 582.81 449.85 576.66 459.08 581.99 448.42 588.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "459.08 581.99 459.08 587.26 448.42 593.42 448.42 588.15 459.08 581.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "439.18 582.81 439.18 588.08 448.42 593.42 448.42 588.15 439.18 582.81"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "443.62 587.86 448.42 590.45 448.42 589.82 443.62 587.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "448.42 592.15 448.42 591.52 442.73 588.71 448.42 592.15"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M439.18,583.71l5.76,3.52-5.76-3.11v-.41Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M350.01,646.14c3-1.5,5.86-3.34,4.94-5.05-.41-.77-1.37-1.12-2.29-1.27-2.77,.91-4.15,1.53-4.15,1.53,0,0,.29-16.08,1.47-22.74,.39-2.2-10.11-2.28-10.11-2.28-.38,1.53-.71,15.05,0,23.28,.24,2.76,.09,4.56-.12,5.9,.72,.31,2.19,.95,3.29,1.45,1.5,.68,3.96,.68,6.96-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M339.64,649.88c1,2.39,3.32,2.17,8,.48,4.15-1.49,7.58-3.18,10.53-5.37,2.95-2.18,2.98-2.47,3.37-3.95,.55-2.07-2.47-3.23-7.49-1.67-.5,.15-.95,.3-1.38,.44,.92,.15,1.88,.5,2.29,1.27,.91,1.71-1.94,3.55-4.94,5.05-3,1.5-5.46,1.5-6.96,.82-1.1-.5-2.57-1.14-3.29-1.45-.3,2.01-.73,2.94-.12,4.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M329.59,665.23h0c-1.98,0-3.6-1.62-3.6-3.6v-33.25c0-1.98,1.62-3.6,3.6-3.6h0c1.98,0,3.6,1.62,3.6,3.6v33.25c0,1.98-1.62,3.6-3.6,3.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 329.59,
    cy: 629.96,
    rx: 22.8,
    ry: 12.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 306.79,
    y: 627.68,
    width: 45.6,
    height: 2.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 329.59,
    cy: 627.68,
    rx: 22.8,
    ry: 12.13
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 329.59,
    cy: 626.36,
    rx: 21.72,
    ry: 11.55
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "309.02 618.94 307.87 626.36 351.32 626.36 350.16 618.94 309.02 618.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M350.46,620.77c0,6.13-9.34,11.1-20.87,11.1s-20.87-4.97-20.87-11.1,9.34-11.1,20.87-11.1,20.87,4.97,20.87,11.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M308.22,682.38c0,2.23-1.36,4.83-3.04,5.8-1.68,.97-3.03-.06-3.03-2.29s1.36-4.83,3.03-5.8c1.68-.97,3.04,.06,3.04,2.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "309.37 681.22 307.03 679.85 303.21 688.34 305.65 689.74 309.37 681.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M310.67,683.79c0,2.24-1.36,4.83-3.04,5.8-1.68,.97-3.03-.06-3.03-2.29s1.36-4.83,3.03-5.8,3.04,.06,3.04,2.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M303.43,681h0c-.7-1.21-.28-2.75,.93-3.45l47.95-27.67c1.21-.7,2.75-.28,3.45,.92h0c.7,1.21,.28,2.75-.93,3.45l-47.95,27.67c-1.21,.7-2.75,.28-3.45-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M352.3,681.93l-47.95-27.67c-1.21-.7-1.62-2.24-.93-3.45h0c.7-1.21,2.24-1.62,3.45-.92l47.95,27.67c1.21,.7,1.62,2.24,.93,3.45h0c-.7,1.21-2.24,1.62-3.45,.92Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M355.23,654.68c0,2.23-1.36,4.83-3.03,5.8-1.68,.97-3.03-.06-3.03-2.29s1.36-4.83,3.03-5.8c1.68-.97,3.03,.06,3.03,2.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "356.38 653.53 354.04 652.15 350.22 660.64 352.66 662.05 356.38 653.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M357.68,656.1c0,2.23-1.36,4.83-3.03,5.8s-3.03-.06-3.03-2.29,1.36-4.83,3.03-5.8c1.68-.97,3.03,.06,3.03,2.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M352.27,683.08c0,2.23-1.36,4.83-3.03,5.8-1.68,.97-3.03-.06-3.03-2.29s1.36-4.83,3.03-5.8c1.68-.97,3.03,.06,3.03,2.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "353.42 681.93 351.08 680.56 347.26 689.05 349.7 690.45 353.42 681.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M354.72,684.5c0,2.23-1.36,4.83-3.04,5.8-1.68,.97-3.03-.06-3.03-2.29s1.36-4.83,3.03-5.8,3.04,.06,3.04,2.29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M306.3,656.26c0,2.23-1.36,4.83-3.03,5.8-1.68,.97-3.04-.06-3.04-2.29s1.36-4.83,3.04-5.8c1.68-.97,3.03,.06,3.03,2.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "307.45 655.11 305.11 653.73 301.29 662.22 303.73 663.63 307.45 655.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M308.75,657.67c0,2.23-1.36,4.83-3.03,5.8-1.68,.97-3.04-.06-3.04-2.29s1.36-4.83,3.04-5.8c1.68-.97,3.03,.06,3.03,2.29Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M369.25,656.88c3-1.5,5.86-3.34,4.94-5.05-.41-.77-1.37-1.12-2.29-1.27-2.77,.91-4.15,1.53-4.15,1.53,0,0,1.49-25.98,2.67-32.64,.39-2.2-10.86,1.86-10.86,1.86-.38,1.53-1.15,20.82-.44,29.05,.24,2.76,.09,4.56-.12,5.9,.72,.31,2.19,.95,3.29,1.45,1.5,.68,3.96,.68,6.96-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M358.88,660.63c1,2.39,3.32,2.17,8,.48,4.15-1.49,7.58-3.18,10.53-5.37,2.95-2.18,2.98-2.47,3.37-3.95,.55-2.07-2.47-3.23-7.49-1.67-.5,.15-.95,.3-1.38,.44,.92,.15,1.88,.5,2.29,1.27,.91,1.71-1.94,3.55-4.94,5.05-3,1.5-5.46,1.5-6.96,.82-1.1-.5-2.57-1.14-3.29-1.45-.3,2.01-.73,2.94-.12,4.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M328.72,527.88c1.13,.79,5.32,1.77,6.55,11.08,.82,6.26-1.25,9.06-3.03,10.69-.74,.68-3.64,.8-3.64,.8l.13,6.98s-4.09,1.62-8.01,0l-3.92-1.62s1.53-2.64,1.28-7.22c-.32-5.67-2.33-13.75-.9-16.75,2.57-5.43,8.49-6.09,11.57-3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M316.65,626.36c3.17,1.76,8.47,4.18,19.44,1.32,13.18-3.43,17.7,1.32,17.7,1.32,0,0,11.64,3.36,15.59-.1,3.95-3.46,3.44-13.28,3.44-13.28,0,0-1.27-10.66-14.24-14.11-7.19-1.91-25.37-7.19-25.37-7.19,0,0-21.69,6.01-23.83,12.37-3.89,11.59,1.57,16.52,7.28,19.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M308.2,607.01c1.96,5.48,10.7,7.53,15.77,7.44,6.77-.11,14.52-3.64,16.82-10.09-.71-2.57-1.48-5.1-2.42-7.51-.66-1.7-3.8-8.81,.94-18.91,2.32-4.94-2.93-13.91-4.41-17.14-1.47-3.23-6.19-5.19-6.19-5.19l-11.93,.19s-4.23,7.48-5.06,13.97c-.83,6.49-1.23,9.24-.2,17.46,.29,2.29,1.11,7.69-2.75,17.59-.21,.54-.4,1.29-.56,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M315.68,555.05s.6,1.96,4.59,3.23c3.99,1.27,7.59,1.03,11.51-.91,.03-2.58-3.13-3.74-3.13-3.74,0,0-3.58,1.44-7.61,0l-4.03-1.44-1.34,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M321.58,524.91c-5.32,1.12-10.92,4.49-8.94,15.81,.85,2.92,2.35,5.41,4.46,7.57,1.05,1.08,2.29,2.23,2.55,3.75,.52-.19,1.04-.42,1.53-.71,.13-.23,.26-.43,.42-.55,5.1-3.64,6.35-5.98,8.69-8.42,2.34-2.45,4.97-3.4,5.27-6.6,.61-6.57-4.01-12.96-13.99-10.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M333.8,560.82c-2.31-.22-4.71,3.98-4.47,9.23,.3,6.72,14.52,22.45,14.52,22.45,4.71,2.79,18.66-5.85,22.07-6.25,3.41-.4,7.76-3.35,9.56-5.61,1.71-2.14-4.84-5.08-8.08-3.01-2.44,1.56-1.81,3.52-3.76,3.81-8.72,1.29-16.7,3.67-16.7,3.67,0,0-8.72-23.86-13.14-24.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M333.94,559.7c-2.96-.41-5.27,1.43-5.88,6.36-.48,3.92,2.24,7.52,2.24,7.52,0,0,.59-6.38,2.53-8.36,2.62-2.68,4.45-1.11,4.45-1.11,0,0,1.71-3.71-3.34-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M332.82,540.34s-2.45-4.2-3.5,0c-.98,3.9,2.42,5.21,2.42,5.21l1.08-5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M312.36,534.32s-1.69,11.44-2.44,15.27-.39,10.26,.25,13.76c.65,3.49,3.95,6.34,3.14,8.84s-4.14,1.39-4.14,1.39c0,0,1.58,2.36,3.77,2.36,1.7,0,3.69-2.05,3.69-2.05,0,0-1.74,5.21,.45,7.24,2.12,1.96,4.28-.5,4.28-.5,0,0-3.41,.02-2.92-1.78,.49-1.79,2.72-.22,3.73-2.91,.41-1.08-1.14-3.5-1.14-3.5,0,0,2.31,1.58,4.07,1.14,1.37-.34,2.37-2.67,2.37-2.67,0,0-2.74,1.95-3.76,.37-1.21-1.87,1.85-2.45,2.32-2.73,.92-.54,2.35-.5,3.09-4.44,.6-3.22,.31-20.81,.31-20.81l-17.08-8.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M320.27,624.04v-26.1c0-9.14-5.61-19.85-12.46-23.81l-6.5-3.76c-6.85-3.96-12.46,.28-12.46,9.42v26.1l31.43,18.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "293.03 569.83 287.7 572.99 292.46 576.15 293.03 569.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "315.08 627.13 320.27 624.04 314.13 618 315.08 627.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M315.08,627.13v-26.1c0-9.14-5.61-19.85-12.46-23.81l-6.5-3.76c-6.85-3.96-12.46,.28-12.46,9.42v26.1l31.43,18.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M295.47,598.78c0,5.53-.55,17.4-.46,20.15,.19,5.97-2.59,23.96,21.19,24.62,2.39,.07,11.68-.34,13.4-1.47-3.91-.18-12.09-1.79-17.07-3.93-15.45-1.42-13.18-13.35-12.97-20.73,.24-8.6,.03-15.61,0-18.49-.04-3.72-4.09-3.89-4.09-.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "123.15 370 123.15 398.11 144.16 386.01 144.16 357.87 123.15 370"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "142.51 361.5 124.75 371.76 124.75 373 142.51 362.71 142.51 361.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "142.51 364.71 124.75 374.97 124.75 376.21 142.51 365.91 142.51 364.71"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "142.51 368.38 124.75 378.65 124.75 379.88 142.51 369.59 142.51 368.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "142.51 371.59 124.75 381.85 124.75 383.09 142.51 372.8 142.51 371.59"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "142.51 375 124.75 385.27 124.75 386.5 142.51 376.21 142.51 375"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "142.51 378.21 124.75 388.47 124.75 389.71 142.51 379.42 142.51 378.21"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "91.76 407.84 91.76 419.82 112.78 407.72 112.78 395.7 91.76 407.84"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "111.13 399.33 93.36 409.6 93.36 410.83 111.13 400.54 111.13 399.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "111.13 402.54 93.36 412.8 93.36 414.04 111.13 403.75 111.13 402.54"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "114.58 375.16 114.58 385.59 105.54 391.1 105.54 380.52 114.58 375.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "141.79 383.79 141.79 394.22 132.74 399.73 132.74 389.15 141.79 383.79"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "432.4 511.67 432.4 523.65 411.38 511.56 411.38 499.54 432.4 511.67"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "413.03 503.17 430.79 513.43 430.79 514.67 413.03 504.38 413.03 503.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "413.03 506.38 430.79 516.64 430.79 517.88 413.03 507.59 413.03 506.38"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "394.98 493.78 394.98 504.2 404.02 509.71 404.02 499.14 394.98 493.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "430.07 520.13 430.07 530.56 439.12 536.07 439.12 525.49 430.07 520.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "278.57 444.46 278.57 456.44 257.56 444.35 257.56 432.33 278.57 444.46"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "259.21 435.96 276.97 446.22 276.97 447.46 259.21 437.17 259.21 435.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "259.21 439.17 276.97 449.43 276.97 450.67 259.21 440.38 259.21 439.17"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "259.38 415.58 259.38 426 268.42 431.51 268.42 420.93 259.38 415.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "244.79 419.23 244.79 429.65 253.83 435.16 253.83 424.59 244.79 419.23"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "299.83 491.46 299.83 519.57 320.85 507.47 320.85 479.33 299.83 491.46"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "319.2 482.96 301.44 493.23 301.44 494.46 319.2 484.17 319.2 482.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "319.2 486.17 301.44 496.43 301.44 497.67 319.2 487.38 319.2 486.17"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "319.2 489.85 301.44 500.11 301.44 501.35 319.2 491.05 319.2 489.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "319.2 493.05 301.44 503.32 301.44 504.55 319.2 494.26 319.2 493.05"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "319.2 496.47 301.44 506.73 301.44 507.97 319.2 497.67 319.2 496.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "319.2 499.67 301.44 509.94 301.44 511.17 319.2 500.88 319.2 499.67"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "271.17 524.34 271.17 552.45 292.18 540.35 292.18 512.21 271.17 524.34"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "290.53 515.84 272.77 526.1 272.77 527.34 290.53 517.05 290.53 515.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "290.53 519.05 272.77 529.31 272.77 530.55 290.53 520.26 290.53 519.05"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "290.53 522.72 272.77 532.99 272.77 534.22 290.53 523.93 290.53 522.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "290.53 525.93 272.77 536.19 272.77 537.43 290.53 527.14 290.53 525.93"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "290.53 529.34 272.77 539.61 272.77 540.84 290.53 530.55 290.53 529.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "290.53 532.55 272.77 542.81 272.77 544.05 290.53 533.76 290.53 532.55"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "301.58 487.73 284.22 497.76 284.22 505.42 301.58 495.42 301.58 487.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "334.25 478.76 334.25 489.18 325.2 494.69 325.2 484.12 334.25 478.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "304.81 513.03 304.81 523.45 295.77 528.96 295.77 518.38 304.81 513.03"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "463.83 538.19 463.83 548.62 472.88 554.13 472.88 543.55 463.83 538.19"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "501.44 547.94 471.33 530.46 471.33 577.23 501.44 594.64 501.44 547.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "481.78 551.52 478.82 549.77 478.82 575.05 481.78 576.77 481.78 551.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "487.03 549.7 484.06 547.95 484.06 578.17 487.03 579.88 487.03 549.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "492.54 566.14 489.57 564.39 489.57 581.5 492.54 583.22 492.54 566.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "498.14 585.95 476.98 573.73 476.98 540.22 475.91 539.51 475.91 574.35 498.14 587.19 498.14 585.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "498.14 576.91 493.85 574.44 493.85 575.67 498.14 578.15 498.14 576.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "498.14 569.15 493.85 566.67 493.85 567.91 498.14 570.38 498.14 569.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "498.14 561.38 493.85 558.9 493.85 560.14 498.14 562.62 498.14 561.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "498.14 553.62 493.85 551.14 493.85 552.38 498.14 554.85 498.14 553.62"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "220.09 313.06 220.09 338.16 198.31 351.43 198.31 325.96 220.09 313.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "201.52 347.11 201.06 346.95 205.8 333.42 208.94 336.69 211.79 326.83 214.47 329.67 217.43 320.18 217.89 320.32 214.69 330.61 212.02 327.78 209.18 337.64 206 334.33 201.52 347.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "201.05 347.46 201.05 326.17 201.53 326.17 201.53 346.59 218.93 335.99 219.19 336.41 201.05 347.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "202.96 324.62 185.59 334.65 185.59 342.31 202.96 332.31 202.96 324.62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsLeftEx);
export default __webpack_public_path__ + "static/media/about-us-left-ex.b82bc1a4f3c186ce668f11b95a262135.svg";
export { ForwardRef as ReactComponent };